(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-listing"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Filtre "Tous nos articles" : clic sur un chip -> filtre les .article-card
     de CETTE page par catégorie (lue dans .article-category, comme la maquette
     Webflow d'origine : cf. spec §1.5), met à jour le compteur avec accord
     singulier/pluriel. 100% front-end, ne connaît pas les articles des autres
     pages de pagination (limite déjà documentée par la spec). */
  function normalize(value) {
    return (value || '').trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function apply(root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('.chip'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('.article-card'));
    var counter = root.querySelector('[data-articles-counter]');
    var active = chips.filter(function (c) { return c.classList.contains('is-active'); })[0];
    var value = active ? normalize(active.textContent) : 'tout';
    var shown = 0;
    cards.forEach(function (card) {
      var catEl = card.querySelector('.article-category');
      var cat = normalize(catEl ? catEl.textContent : '');
      var show = value === 'tout' || cat === value;
      card.style.display = show ? '' : 'none';
      if (show) shown += 1;
    });
    if (counter) {
      counter.textContent = shown + (shown === 1 ? ' article affiché' : ' articles affichés');
    }
  }

  function bind(root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('.chip'));
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-pressed', 'false'); });
        chip.classList.add('is-active');
        chip.setAttribute('aria-pressed', 'true');
        apply(root);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-blog-filter]').forEach(function (root) {
      bind(root);
      apply(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boutique-catalog"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Palier de pagination (demande Murat : 39, multiple de 3) : miroir du
     `batch_size` Liquid ci-dessus, utilisé uniquement pour le rendu serveur
     sans JS. Ici c'est la seule source de vérité du comportement interactif. */
  var BATCH_SIZE = 39;

  function getState(section) {
    if (!section._odaCatalog) {
      var slider = section.querySelector('[data-price-slider]');
      var boundsMin = slider ? parseInt(slider.getAttribute('data-price-floor'), 10) || 0 : 0;
      var boundsMax = slider ? parseInt(slider.getAttribute('data-price-ceiling'), 10) || 0 : 0;

      /* Groupes d'options dynamiques (Taille, Saveur...), découverts sur le
         DOM déjà rendu par Liquid : Marque et Catégorie restent des groupes
         à part, toujours présents, jamais mélangés à cette liste. */
      var optionGroups = [].slice.call(section.querySelectorAll('.filter-item[data-option-group]')).map(function (item) {
        return item.getAttribute('data-filter-group');
      });
      var selected = { marque: [], categorie: [] };
      optionGroups.forEach(function (slug) { selected[slug] = []; });

      section._odaCatalog = {
        selected: selected,
        optionGroups: optionGroups,
        priceMin: boundsMin,
        priceMax: boundsMax,
        priceBoundsMin: boundsMin,
        priceBoundsMax: boundsMax,
        currencySymbol: slider ? (slider.getAttribute('data-currency-symbol') || '') : '',
        sort: 'meilleures-ventes',
        /* Nombre de cartes MONTRÉES parmi le résultat filtré (pagination par
           lots de 39, demande Murat) : jamais confondu avec le compteur, qui
           lui affiche toujours le TOTAL du résultat filtré. */
        visibleCount: BATCH_SIZE
      };
    }
    return section._odaCatalog;
  }

  function closeAllDropdowns(section) {
    section.querySelectorAll('.filter-item.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      item.setAttribute('aria-expanded', 'false');
    });
    section.querySelectorAll('.shop-dropdown.is-open').forEach(function (dd) {
      dd.classList.remove('is-open');
    });
  }

  function openDropdown(item) {
    var section = item.closest('[data-boutique-catalog]');
    if (!section) return;
    var dd = item.querySelector('.shop-dropdown');
    var alreadyOpen = item.classList.contains('is-open');
    closeAllDropdowns(section);
    if (!alreadyOpen && dd) {
      item.classList.add('is-open');
      item.setAttribute('aria-expanded', 'true');
      dd.classList.add('is-open');
    }
  }

  /* --- Panneau de filtres mobile (≤767) -----------------------------------
     Ouvre/ferme le MÊME .filter-group (cf. stylesheet, "Panneau de filtres
     mobile") : aucune donnée de filtre n'est dupliquée, ce bloc ne pilote
     que la visibilité du panneau (classes + verrou de scroll), jamais
     l'état des filtres eux-mêmes. */
  function openFiltersPanel(section) {
    var panel = section.querySelector('[data-filters-panel]');
    if (!panel) return;
    var backdrop = section.querySelector('[data-filters-backdrop]');
    var toggle = section.querySelector('[data-filters-toggle]');
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.classList.add('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('shop-filters-panel-open');
    var closeBtn = panel.querySelector('[data-filters-close]');
    window.setTimeout(function () {
      if (!closeBtn) return;
      try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
    }, 50);
  }

  function closeFiltersPanel(section) {
    var panel = section.querySelector('[data-filters-panel]');
    if (!panel || !panel.classList.contains('is-open')) return;
    var backdrop = section.querySelector('[data-filters-backdrop]');
    var toggle = section.querySelector('[data-filters-toggle]');
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      try { toggle.focus({ preventScroll: true }); } catch (e) {}
    }
    document.documentElement.classList.remove('shop-filters-panel-open');
  }

  function labelFor(option) {
    var span = option.querySelector('span:last-child');
    return span ? span.textContent.trim() : (option.dataset.value || '');
  }

  function findOption(section, group, value) {
    var dropdown = section.querySelector('.shop-dropdown[data-dropdown="' + group + '"]');
    if (!dropdown) return null;
    var found = null;
    dropdown.querySelectorAll('.shop-dropdown-option').forEach(function (opt) {
      if (opt.dataset.value === value) found = opt;
    });
    return found;
  }

  /* Toute action qui change l'ensemble filtré ou son ordre réinitialise la
     pagination à 39 (demande Murat : "se réapplique après filtrage") : sur
     le NOUVEL ensemble, jamais un reliquat d'un état précédent plus large. */
  function resetPagination(section) {
    getState(section).visibleCount = BATCH_SIZE;
  }

  function toggleCheckbox(section, group, option) {
    var state = getState(section);
    var value = option.dataset.value;
    var list = state.selected[group];
    var idx = list.indexOf(value);
    if (idx === -1) {
      list.push(value);
      option.classList.add('is-checked');
      option.setAttribute('aria-selected', 'true');
    } else {
      list.splice(idx, 1);
      option.classList.remove('is-checked');
      option.setAttribute('aria-selected', 'false');
    }
    resetPagination(section);
    render(section);
  }

  function selectSort(section, option) {
    var state = getState(section);
    state.sort = option.dataset.value;
    section.querySelectorAll('[data-dropdown="tri"] .shop-dropdown-option').forEach(function (opt) {
      var active = opt === option;
      opt.classList.toggle('is-checked', active);
      opt.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    var labelEl = section.querySelector('[data-sort-label]');
    if (labelEl) labelEl.textContent = labelFor(option);
    resetPagination(section);
    render(section);
  }

  function matches(card, state) {
    var marque = card.dataset.marque || '';
    var categorie = card.dataset.categorie || '';
    var price = priceOf(card);

    var okMarque = !state.selected.marque.length || state.selected.marque.indexOf(marque) !== -1;
    var okCategorie = !state.selected.categorie.length || state.selected.categorie.indexOf(categorie) !== -1;
    var okOptions = state.optionGroups.every(function (slug) {
      var chosen = state.selected[slug] || [];
      if (!chosen.length) return true;
      var values = (card.getAttribute('data-opt-' + slug) || '').split(' ').filter(Boolean);
      return chosen.some(function (v) { return values.indexOf(v) !== -1; });
    });
    var okPrix = price >= state.priceMin && price <= state.priceMax;
    return okMarque && okCategorie && okOptions && okPrix;
  }

  function priceOf(card) { return parseInt(card.dataset.price, 10) || 0; }
  function orderOf(card) { return parseInt(card.dataset.order, 10) || 0; }

  function formatPrice(cents, symbol) {
    var major = Math.round(cents / 100);
    return major + ' ' + symbol;
  }

  function syncPriceUI(section) {
    var state = getState(section);
    var slider = section.querySelector('[data-price-slider]');
    if (!slider) return;
    var minInput = slider.querySelector('[data-price-input="min"]');
    var maxInput = slider.querySelector('[data-price-input="max"]');
    var rangeEl = slider.querySelector('[data-price-range]');
    /* RETOUR MURAT (03/09) : les 2 anciens <span> data-price-min-label/
       data-price-max-label sont devenus 2 champs number éditables
       (data-price-number). Synchronisation dans les 2 sens : la jauge
       écrit ici dans les champs ; les champs pilotent la jauge via
       handlePriceNumberInput plus bas. Le garde-fou `document.activeElement
       !== field` évite d'écraser ce que l'utilisateur est en train de
       taper dans CE champ précis pendant que la jauge se resynchronise
       (ex. l'autre poignée bouge et déclenche un render()). */
    var minField = slider.querySelector('[data-price-number="min"]');
    var maxField = slider.querySelector('[data-price-number="max"]');

    if (minInput && parseInt(minInput.value, 10) !== state.priceMin) minInput.value = state.priceMin;
    if (maxInput && parseInt(maxInput.value, 10) !== state.priceMax) maxInput.value = state.priceMax;
    if (minField && document.activeElement !== minField) minField.value = Math.round(state.priceMin / 100);
    if (maxField && document.activeElement !== maxField) maxField.value = Math.round(state.priceMax / 100);

    var span = state.priceBoundsMax - state.priceBoundsMin;
    if (span <= 0) span = 1;
    var startPct = ((state.priceMin - state.priceBoundsMin) / span) * 100;
    var endPct = ((state.priceMax - state.priceBoundsMin) / span) * 100;
    if (rangeEl) {
      rangeEl.style.left = startPct + '%';
      rangeEl.style.width = Math.max(0, endPct - startPct) + '%';
    }

    if (minInput && maxInput) {
      var minInFront = startPct >= 50;
      minInput.style.zIndex = minInFront ? '5' : '4';
      maxInput.style.zIndex = minInFront ? '4' : '5';
    }

    if (minInput) minInput.setAttribute('aria-valuetext', formatPrice(state.priceMin, state.currencySymbol));
    if (maxInput) maxInput.setAttribute('aria-valuetext', formatPrice(state.priceMax, state.currencySymbol));
  }

  function handlePriceInput(section, input) {
    var state = getState(section);
    var slider = input.closest('[data-price-slider]');
    if (!slider) return;
    var minInput = slider.querySelector('[data-price-input="min"]');
    var maxInput = slider.querySelector('[data-price-input="max"]');
    var minVal = parseInt(minInput.value, 10);
    var maxVal = parseInt(maxInput.value, 10);

    if (minVal > maxVal) {
      if (input === minInput) { minVal = maxVal; minInput.value = minVal; }
      else { maxVal = minVal; maxInput.value = maxVal; }
    }

    state.priceMin = minVal;
    state.priceMax = maxVal;
    resetPagination(section);
    render(section);
  }

  /* RETOUR MURAT (03/09) : pilote la jauge depuis les 2 champs number
     (unité majeure de la devise, ex. "45"), déclenché sur `change` (perte
     de focus / Entrée), pas sur chaque frappe, sinon un "1" tapé avant
     "12" filtrerait déjà sur 1 CHF le temps de taper le 2e chiffre. Mêmes
     règles que la jauge : bornes [priceBoundsMin, priceBoundsMax], et
     min <= max (le champ qu'on vient d'éditer gagne, l'autre s'aligne
     dessus : même arbitrage que handlePriceInput pour la jauge). */
  function handlePriceNumberInput(section, input) {
    var state = getState(section);
    var slider = input.closest('[data-price-slider]');
    if (!slider) return;
    var minField = slider.querySelector('[data-price-number="min"]');
    var maxField = slider.querySelector('[data-price-number="max"]');
    if (!minField || !maxField) return;

    var boundsMinMajor = Math.round(state.priceBoundsMin / 100);
    var boundsMaxMajor = Math.round(state.priceBoundsMax / 100);

    var minVal = parseInt(minField.value, 10);
    var maxVal = parseInt(maxField.value, 10);
    if (isNaN(minVal)) minVal = boundsMinMajor;
    if (isNaN(maxVal)) maxVal = boundsMaxMajor;

    minVal = Math.min(Math.max(minVal, boundsMinMajor), boundsMaxMajor);
    maxVal = Math.min(Math.max(maxVal, boundsMinMajor), boundsMaxMajor);

    if (minVal > maxVal) {
      if (input === minField) maxVal = minVal;
      else minVal = maxVal;
    }

    state.priceMin = minVal * 100;
    state.priceMax = maxVal * 100;
    resetPagination(section);
    render(section);
  }

  function resetPriceFilter(section) {
    var state = getState(section);
    state.priceMin = state.priceBoundsMin;
    state.priceMax = state.priceBoundsMax;
    resetPagination(section);
    render(section);
  }

  function loadMore(section) {
    var state = getState(section);
    state.visibleCount += BATCH_SIZE;
    render(section);
  }

  function render(section) {
    var state = getState(section);
    syncPriceUI(section);
    var grid = section.querySelector('[data-products-grid]');
    if (!grid) return;
    var counter = section.querySelector('[data-counter]');
    var emptyState = section.querySelector('[data-empty-state]');
    var loadMoreBtn = section.querySelector('[data-load-more]');

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));
    var matched = cards.filter(function (c) { return matches(c, state); });

    if (state.sort === 'prix-croissant') {
      matched.sort(function (a, b) { return priceOf(a) - priceOf(b); });
    } else if (state.sort === 'prix-decroissant') {
      matched.sort(function (a, b) { return priceOf(b) - priceOf(a); });
    } else {
      matched.sort(function (a, b) { return orderOf(a) - orderOf(b); });
    }
    matched.forEach(function (c) { grid.appendChild(c); });

    /* Compteur = TOTAL du résultat filtré (demande Murat), pagination
       comprise : jamais le nombre de cartes réellement visibles. */
    var total = matched.length;

    /* Pagination par lots de 39 sur le résultat FILTRÉ (demande Murat) :
       visibleCount ne dépasse jamais le total courant (filtre qui réduit le
       résultat après un "charger plus" déjà cliqué plusieurs fois). */
    if (state.visibleCount > total) state.visibleCount = total;
    if (state.visibleCount < BATCH_SIZE && total > 0) {
      state.visibleCount = Math.min(BATCH_SIZE, total);
    }

    cards.forEach(function (c) { c.hidden = true; });
    matched.slice(0, state.visibleCount).forEach(function (c) { c.hidden = false; });

    if (counter) {
      counter.textContent = total + ' ' + (total < 2 ? 'produit' : 'produits');
    }
    /* Compteur du pied de panneau mobile ("Voir les N produits") : même
       valeur TOTALE que le compteur principal (pagination comprise, demande
       Murat), jamais un 2e calcul ni le nombre de cartes réellement visibles. */
    var mobileCount = section.querySelector('[data-filters-count]');
    var mobileNoun = section.querySelector('[data-filters-count-noun]');
    if (mobileCount) mobileCount.textContent = total;
    if (mobileNoun) mobileNoun.textContent = total < 2 ? 'produit' : 'produits';
    if (loadMoreBtn) loadMoreBtn.hidden = state.visibleCount >= total;
    if (emptyState) emptyState.hidden = total > 0;
    grid.hidden = total === 0;

    renderChips(section);
  }

  function renderChips(section) {
    var state = getState(section);
    var chipsRow = section.querySelector('[data-chips-row]');
    if (!chipsRow) return;
    chipsRow.innerHTML = '';
    var groups = ['marque', 'categorie'].concat(state.optionGroups);
    var priceNarrowed = state.priceMin > state.priceBoundsMin || state.priceMax < state.priceBoundsMax;
    var any = groups.some(function (g) { return state.selected[g].length; }) || priceNarrowed;
    chipsRow.classList.toggle('is-visible', any);
    if (!any) return;

    groups.forEach(function (group) {
      state.selected[group].forEach(function (value) {
        var option = findOption(section, group, value);
        var label = option ? labelFor(option) : value;
        addChip(chipsRow, label, function () { removeFilter(section, group, value); });
      });
    });

    if (priceNarrowed) {
      var priceLabel = formatPrice(state.priceMin, state.currencySymbol) + ' à ' + formatPrice(state.priceMax, state.currencySymbol);
      addChip(chipsRow, priceLabel, function () { resetPriceFilter(section); });
    }

    var clearAll = document.createElement('div');
    clearAll.className = 'shop-chip is-clear-all';
    clearAll.setAttribute('role', 'button');
    clearAll.setAttribute('tabindex', '0');
    clearAll.textContent = section.getAttribute('data-clear-label') || 'tout effacer';
    clearAll.addEventListener('click', function () { clearAllFilters(section); });
    clearAll.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); clearAllFilters(section); }
    });
    chipsRow.appendChild(clearAll);
  }

  function addChip(row, label, onRemove) {
    var chip = document.createElement('div');
    chip.className = 'shop-chip';
    var txt = document.createElement('span');
    txt.textContent = label;
    var x = document.createElement('span');
    x.className = 'shop-chip-remove';
    x.setAttribute('role', 'button');
    x.setAttribute('tabindex', '0');
    x.setAttribute('aria-label', 'Retirer ce filtre');
    x.textContent = '×';
    x.addEventListener('click', onRemove);
    x.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onRemove(); }
    });
    chip.appendChild(txt);
    chip.appendChild(x);
    row.appendChild(chip);
  }

  function removeFilter(section, group, value) {
    var state = getState(section);
    var list = state.selected[group];
    var idx = list.indexOf(value);
    if (idx !== -1) list.splice(idx, 1);
    var option = findOption(section, group, value);
    if (option) { option.classList.remove('is-checked'); option.setAttribute('aria-selected', 'false'); }
    resetPagination(section);
    render(section);
  }

  function clearAllFilters(section) {
    var state = getState(section);
    ['marque', 'categorie'].concat(state.optionGroups).forEach(function (group) {
      state.selected[group] = [];
      section.querySelectorAll('.shop-dropdown[data-dropdown="' + group + '"] .shop-dropdown-option').forEach(function (opt) {
        opt.classList.remove('is-checked');
        opt.setAttribute('aria-selected', 'false');
      });
    });
    state.priceMin = state.priceBoundsMin;
    state.priceMax = state.priceBoundsMax;
    resetPagination(section);
    render(section);
  }

  /* --- Délégation globale : un seul jeu de listeners, jamais reperdu
     (aucune carte n'est jamais recréée : elles existent toutes dès le
     rendu serveur, seul `hidden` bascule au filtrage/à la pagination). ---- */

  document.addEventListener('click', function (e) {
    var section = e.target.closest('[data-boutique-catalog]');
    if (!section) {
      document.querySelectorAll('[data-boutique-catalog]').forEach(closeAllDropdowns);
      return;
    }

    if (e.target.closest('[data-filters-toggle]')) { openFiltersPanel(section); return; }
    if (e.target.closest('[data-filters-close]') || e.target.closest('[data-filters-backdrop]') || e.target.closest('[data-filters-apply]')) {
      closeFiltersPanel(section);
      return;
    }

    var option = e.target.closest('.shop-dropdown-option');
    if (option) {
      var dropdown = option.closest('.shop-dropdown');
      var group = dropdown ? dropdown.getAttribute('data-dropdown') : null;
      if (group === 'tri') {
        selectSort(section, option);
        closeAllDropdowns(section);
      } else if (group) {
        toggleCheckbox(section, group, option);
      }
      return;
    }

    if (e.target.closest('[data-clear-filters-empty]')) {
      clearAllFilters(section);
      return;
    }

    if (e.target.closest('[data-load-more]')) {
      loadMore(section);
      return;
    }

    var filterItem = e.target.closest('.filter-item');
    if (filterItem && section.contains(filterItem)) {
      if (!e.target.closest('.shop-dropdown')) {
        openDropdown(filterItem);
      }
      return;
    }

    closeAllDropdowns(section);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-boutique-catalog]').forEach(function (section) {
        closeAllDropdowns(section);
        closeFiltersPanel(section);
      });
      return;
    }
    if (e.key !== 'Enter' && e.key !== ' ') return;

    var option = e.target.closest('.shop-dropdown-option');
    if (option) {
      e.preventDefault();
      var section = option.closest('[data-boutique-catalog]');
      var dropdown = option.closest('.shop-dropdown');
      var group = dropdown ? dropdown.getAttribute('data-dropdown') : null;
      if (!section || !group) return;
      if (group === 'tri') { selectSort(section, option); closeAllDropdowns(section); }
      else { toggleCheckbox(section, group, option); }
      return;
    }

    var filterItem = e.target.closest('.filter-item');
    if (filterItem && !e.target.closest('.shop-dropdown')) {
      e.preventDefault();
      openDropdown(filterItem);
    }
  });

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-price-input]');
    if (!input) return;
    var section = input.closest('[data-boutique-catalog]');
    if (!section) return;
    handlePriceInput(section, input);
  });

  /* RETOUR MURAT (03/09) : champs Prix éditables. `change` (perte de focus
     ou Entrée), pas `input`, pour ne pas relancer le filtre à chaque
     chiffre tapé. */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-price-number]');
    if (!input) return;
    var section = input.closest('[data-boutique-catalog]');
    if (!section) return;
    handlePriceNumberInput(section, input);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-price-number]');
    if (!input) return;
    e.preventDefault();
    input.blur();
  });

  function init() {
    document.querySelectorAll('[data-boutique-catalog]').forEach(function (section) {
      /* La section a pu être re-rendue par l'éditeur de thème : on repart
         d'un état neuf (visibleCount = 39) plutôt que de garder des
         références obsolètes. */
      section._odaCatalog = null;
      render(section);
      /* Panneau mobile toujours refermé après un rendu (initial ou
         shopify:section:load) : jamais rouvert dans un état incohérent si
         l'éditeur recrée la section pendant qu'il était ouvert. */
      var panel = section.querySelector('[data-filters-panel]');
      if (panel && panel.classList.contains('is-open')) closeFiltersPanel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-catalog"] && !Shopify.designMode) return;
  try {
    
(function () {
  function getState(section) {
    if (!section._odaCatalog) {
      /* Bornes de la jauge Prix lues sur le DOM au premier accès à l'état
         (posées par Liquid en data-attributes, cf. price_floor_cents /
         price_ceil_cents) : jamais codées en dur ici, la section peut être
         réutilisée sur n'importe quelle collection avec des prix différents. */
      var slider = section.querySelector('[data-price-slider]');
      var boundsMin = slider ? parseInt(slider.getAttribute('data-price-floor'), 10) || 0 : 0;
      var boundsMax = slider ? parseInt(slider.getAttribute('data-price-ceiling'), 10) || 0 : 0;

      /* Groupes d'options dynamiques (Taille, Saveur...), découverts sur le
         DOM déjà rendu par Liquid plutôt que codés en dur : chaque
         .filter-item de groupe porte data-option-group + data-filter-group
         = son slug (cf. la boucle option_group_names dans le markup).
         Catégorie et Prix restent des circuits à part, inchangés par cette
         généralisation (cf. tête de fichier). */
      var optionGroups = [].slice.call(section.querySelectorAll('.filter-item[data-option-group]')).map(function (item) {
        return item.getAttribute('data-filter-group');
      });
      var selected = { categorie: [] };
      optionGroups.forEach(function (slug) { selected[slug] = []; });

      section._odaCatalog = {
        selected: selected,
        optionGroups: optionGroups,
        priceMin: boundsMin,
        priceMax: boundsMax,
        priceBoundsMin: boundsMin,
        priceBoundsMax: boundsMax,
        currencySymbol: slider ? (slider.getAttribute('data-currency-symbol') || '') : '',
        sort: 'meilleures-ventes'
      };
    }
    return section._odaCatalog;
  }

  function closeAllDropdowns(section) {
    section.querySelectorAll('.filter-item.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      item.setAttribute('aria-expanded', 'false');
    });
    section.querySelectorAll('.shop-dropdown.is-open').forEach(function (dd) {
      dd.classList.remove('is-open');
    });
  }

  function openDropdown(item) {
    var section = item.closest('[data-collection-catalog]');
    if (!section) return;
    var dd = item.querySelector('.shop-dropdown');
    var alreadyOpen = item.classList.contains('is-open');
    closeAllDropdowns(section);
    if (!alreadyOpen && dd) {
      item.classList.add('is-open');
      item.setAttribute('aria-expanded', 'true');
      dd.classList.add('is-open');
    }
  }

  /* --- Panneau de filtres mobile (≤767) -----------------------------------
     Ouvre/ferme le MÊME .filter-group (cf. stylesheet, "Panneau de filtres
     mobile") : aucune donnée de filtre n'est dupliquée, ce bloc ne pilote
     que la visibilité du panneau (classes + verrou de scroll), jamais
     l'état des filtres eux-mêmes. */
  function openFiltersPanel(section) {
    var panel = section.querySelector('[data-filters-panel]');
    if (!panel) return;
    var backdrop = section.querySelector('[data-filters-backdrop]');
    var toggle = section.querySelector('[data-filters-toggle]');
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.classList.add('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('shop-filters-panel-open');
    var closeBtn = panel.querySelector('[data-filters-close]');
    window.setTimeout(function () {
      if (!closeBtn) return;
      try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
    }, 50);
  }

  function closeFiltersPanel(section) {
    var panel = section.querySelector('[data-filters-panel]');
    if (!panel || !panel.classList.contains('is-open')) return;
    var backdrop = section.querySelector('[data-filters-backdrop]');
    var toggle = section.querySelector('[data-filters-toggle]');
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.classList.remove('is-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      try { toggle.focus({ preventScroll: true }); } catch (e) {}
    }
    document.documentElement.classList.remove('shop-filters-panel-open');
  }

  function labelFor(option) {
    var span = option.querySelector('span:last-child');
    return span ? span.textContent.trim() : (option.dataset.value || '');
  }

  function findOption(section, group, value) {
    var dropdown = section.querySelector('.shop-dropdown[data-dropdown="' + group + '"]');
    if (!dropdown) return null;
    var found = null;
    dropdown.querySelectorAll('.shop-dropdown-option').forEach(function (opt) {
      if (opt.dataset.value === value) found = opt;
    });
    return found;
  }

  function toggleCheckbox(section, group, option) {
    var state = getState(section);
    var value = option.dataset.value;
    var list = state.selected[group];
    var idx = list.indexOf(value);
    if (idx === -1) {
      list.push(value);
      option.classList.add('is-checked');
      option.setAttribute('aria-selected', 'true');
    } else {
      list.splice(idx, 1);
      option.classList.remove('is-checked');
      option.setAttribute('aria-selected', 'false');
    }
    render(section);
  }

  function selectSort(section, option) {
    var state = getState(section);
    state.sort = option.dataset.value;
    section.querySelectorAll('[data-dropdown="tri"] .shop-dropdown-option').forEach(function (opt) {
      var active = opt === option;
      opt.classList.toggle('is-checked', active);
      opt.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    var labelEl = section.querySelector('[data-sort-label]');
    if (labelEl) labelEl.textContent = labelFor(option);
    render(section);
  }

  function matches(card, state) {
    var categorie = card.dataset.categorie || '';
    var price = priceOf(card);

    var okCategorie = !state.selected.categorie.length || state.selected.categorie.indexOf(categorie) !== -1;
    /* Groupes d'options dynamiques (Taille, Saveur...) : même logique OU-dans-
       le-groupe qu'avant (une carte passe si elle porte AU MOINS UNE des
       valeurs cochées dans ce groupe), répétée pour chaque groupe présent
       sur cette collection puis combinée en ET, comme Catégorie et Prix.
       Une carte sans attribut pour ce groupe (ex. produit sans option) a une
       liste de valeurs vide : elle ne matche aucune sélection active, donc
       est exclue dès qu'un filtre de ce groupe est coché, exactement comme
       avant pour un produit sans taille. */
    var okOptions = state.optionGroups.every(function (slug) {
      var chosen = state.selected[slug] || [];
      if (!chosen.length) return true;
      var values = (card.getAttribute('data-opt-' + slug) || '').split(' ').filter(Boolean);
      return chosen.some(function (v) { return values.indexOf(v) !== -1; });
    });
    var okPrix = price >= state.priceMin && price <= state.priceMax;
    return okCategorie && okOptions && okPrix;
  }

  function priceOf(card) { return parseInt(card.dataset.price, 10) || 0; }
  function orderOf(card) { return parseInt(card.dataset.order, 10) || 0; }

  /* --- Jauge Prix (retour Murat du 21/08) ---------------------------------
     Même state de filtres, même render() que les dropdowns Catégorie et les
     groupes d'options (Taille, Saveur...) (pas de 2e circuit de filtrage) :
     priceMin/priceMax vivent directement sur l'objet renvoyé par getState(),
     matches() les lit comme le reste. */

  function formatPrice(cents, symbol) {
    var major = Math.round(cents / 100);
    return major + ' ' + symbol;
  }

  function syncPriceUI(section) {
    var state = getState(section);
    var slider = section.querySelector('[data-price-slider]');
    if (!slider) return;
    var minInput = slider.querySelector('[data-price-input="min"]');
    var maxInput = slider.querySelector('[data-price-input="max"]');
    var rangeEl = slider.querySelector('[data-price-range]');

    /* RETOUR MURAT (03/09) : les 2 anciens <span> data-price-min-label/
       data-price-max-label sont devenus 2 champs number éditables
       (data-price-number). Synchronisation dans les 2 sens : la jauge
       écrit ici dans les champs ; les champs pilotent la jauge via
       handlePriceNumberInput plus bas. Le garde-fou `document.activeElement
       !== field` évite d'écraser ce que l'utilisateur est en train de
       taper dans CE champ précis pendant que la jauge se resynchronise
       (ex. l'autre poignée bouge et déclenche un render()). */
    var minField = slider.querySelector('[data-price-number="min"]');
    var maxField = slider.querySelector('[data-price-number="max"]');

    if (minInput && parseInt(minInput.value, 10) !== state.priceMin) minInput.value = state.priceMin;
    if (maxInput && parseInt(maxInput.value, 10) !== state.priceMax) maxInput.value = state.priceMax;
    if (minField && document.activeElement !== minField) minField.value = Math.round(state.priceMin / 100);
    if (maxField && document.activeElement !== maxField) maxField.value = Math.round(state.priceMax / 100);

    var span = state.priceBoundsMax - state.priceBoundsMin;
    if (span <= 0) span = 1;
    var startPct = ((state.priceMin - state.priceBoundsMin) / span) * 100;
    var endPct = ((state.priceMax - state.priceBoundsMin) / span) * 100;
    if (rangeEl) {
      rangeEl.style.left = startPct + '%';
      rangeEl.style.width = Math.max(0, endPct - startPct) + '%';
    }

    /* CORRECTION relecture : les deux <input> occupent exactement la même
       boîte, donc le dernier du DOM (la poignée haute) capte le clic partout
       où les deux se superposent. Poussées toutes les deux au plafond, la
       poignée basse devenait impossible à rattraper à la souris, et la haute
       ne pouvait plus redescendre puisqu'elle est bornée par la basse : la
       jauge se bloquait, seule la croix du chip ou le clavier la débloquait.
       On fait donc passer la poignée basse devant dès qu'elle entre dans la
       moitié haute de la piste. Un empilement positionnel, pas un empilement
       au clic : il reste juste même si l'utilisateur clique sans déplacer. */
    if (minInput && maxInput) {
      var minInFront = startPct >= 50;
      minInput.style.zIndex = minInFront ? '5' : '4';
      maxInput.style.zIndex = minInFront ? '4' : '5';
    }

    /* Sans aria-valuetext, un lecteur d'écran annonce la valeur brute de
       l'input, en centimes (« 4900 ») : on lui donne le prix lisible. */
    if (minInput) minInput.setAttribute('aria-valuetext', formatPrice(state.priceMin, state.currencySymbol));
    if (maxInput) maxInput.setAttribute('aria-valuetext', formatPrice(state.priceMax, state.currencySymbol));
  }

  function handlePriceInput(section, input) {
    var state = getState(section);
    var slider = input.closest('[data-price-slider]');
    if (!slider) return;
    var minInput = slider.querySelector('[data-price-input="min"]');
    var maxInput = slider.querySelector('[data-price-input="max"]');
    var minVal = parseInt(minInput.value, 10);
    var maxVal = parseInt(maxInput.value, 10);

    /* Empêche les deux poignées de se croiser : chacune est bornée par la
       position courante de l'autre plutôt que par les bornes globales. */
    if (minVal > maxVal) {
      if (input === minInput) { minVal = maxVal; minInput.value = minVal; }
      else { maxVal = minVal; maxInput.value = maxVal; }
    }

    state.priceMin = minVal;
    state.priceMax = maxVal;
    render(section);
  }

  /* RETOUR MURAT (03/09) : pilote la jauge depuis les 2 champs number
     (unité majeure de la devise, ex. "45"), déclenché sur `change` (perte
     de focus / Entrée), pas sur chaque frappe, sinon un "1" tapé avant
     "12" filtrerait déjà sur 1 CHF le temps de taper le 2e chiffre. Mêmes
     règles que la jauge : bornes [priceBoundsMin, priceBoundsMax], et
     min <= max (le champ qu'on vient d'éditer gagne, l'autre s'aligne
     dessus : même arbitrage que handlePriceInput pour la jauge). */
  function handlePriceNumberInput(section, input) {
    var state = getState(section);
    var slider = input.closest('[data-price-slider]');
    if (!slider) return;
    var minField = slider.querySelector('[data-price-number="min"]');
    var maxField = slider.querySelector('[data-price-number="max"]');
    if (!minField || !maxField) return;

    var boundsMinMajor = Math.round(state.priceBoundsMin / 100);
    var boundsMaxMajor = Math.round(state.priceBoundsMax / 100);

    var minVal = parseInt(minField.value, 10);
    var maxVal = parseInt(maxField.value, 10);
    if (isNaN(minVal)) minVal = boundsMinMajor;
    if (isNaN(maxVal)) maxVal = boundsMaxMajor;

    minVal = Math.min(Math.max(minVal, boundsMinMajor), boundsMaxMajor);
    maxVal = Math.min(Math.max(maxVal, boundsMinMajor), boundsMaxMajor);

    if (minVal > maxVal) {
      if (input === minField) maxVal = minVal;
      else minVal = maxVal;
    }

    state.priceMin = minVal * 100;
    state.priceMax = maxVal * 100;
    render(section);
  }

  function resetPriceFilter(section) {
    var state = getState(section);
    state.priceMin = state.priceBoundsMin;
    state.priceMax = state.priceBoundsMax;
    render(section);
  }

  function render(section) {
    var state = getState(section);
    /* Même render() pour tous les filtres (retour Murat du 21/08) : la
       jauge Prix ne déclenche pas un 2e circuit, elle met juste à jour
       state.priceMin/priceMax puis rappelle celui-ci, comme les dropdowns. */
    syncPriceUI(section);
    var grid = section.querySelector('[data-products-grid]');
    if (!grid) return;
    var counter = section.querySelector('[data-counter]');
    var emptyState = section.querySelector('[data-empty-state]');

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));
    var matched = cards.filter(function (c) { return matches(c, state); });

    /* "meilleures ventes" = ordre source (position dans la collection).
       CORRECTION relecture : le Webflow se contentait de "ne rien réordonner",
       ce qui laissait la grille figée dans l'ordre du dernier tri par prix :
       revenir sur "meilleures ventes" ne restaurait rien. On repose l'ordre
       d'origine avec data-order. */
    if (state.sort === 'prix-croissant') {
      matched.sort(function (a, b) { return priceOf(a) - priceOf(b); });
    } else if (state.sort === 'prix-decroissant') {
      matched.sort(function (a, b) { return priceOf(b) - priceOf(a); });
    } else {
      matched.sort(function (a, b) { return orderOf(a) - orderOf(b); });
    }
    matched.forEach(function (c) { grid.appendChild(c); });

    /* Retour Murat du 21/08 : plus de pagination : toutes les cartes qui
       correspondent aux filtres actifs sont montrées d'un coup, jamais par
       palier. Seul le filtrage masque encore des cartes (`hidden`). */
    var total = matched.length;

    cards.forEach(function (c) { c.hidden = true; });
    matched.forEach(function (c) { c.hidden = false; });

    if (counter) {
      counter.textContent = total + ' ' + (total < 2 ? 'produit affiché' : 'produits affichés');
    }
    /* Compteur du pied de panneau mobile ("Voir les N produits") : même
       valeur que le compteur principal, jamais un 2e calcul. */
    var mobileCount = section.querySelector('[data-filters-count]');
    var mobileNoun = section.querySelector('[data-filters-count-noun]');
    if (mobileCount) mobileCount.textContent = total;
    if (mobileNoun) mobileNoun.textContent = total < 2 ? 'produit' : 'produits';
    if (emptyState) emptyState.hidden = total > 0;
    grid.hidden = total === 0;

    renderChips(section);
  }

  function renderChips(section) {
    var state = getState(section);
    var chipsRow = section.querySelector('[data-chips-row]');
    if (!chipsRow) return;
    chipsRow.innerHTML = '';
    /* Catégorie + tous les groupes d'options dynamiques découverts (Taille,
       Saveur...) : jamais une liste figée, cf. state.optionGroups posé par
       getState(). */
    var groups = ['categorie'].concat(state.optionGroups);
    /* "Resserrée" = au moins une des deux poignées a bougé depuis les bornes
       réelles de la collection (retour Murat du 21/08). */
    var priceNarrowed = state.priceMin > state.priceBoundsMin || state.priceMax < state.priceBoundsMax;
    var any = groups.some(function (g) { return state.selected[g].length; }) || priceNarrowed;
    chipsRow.classList.toggle('is-visible', any);
    if (!any) return;

    groups.forEach(function (group) {
      state.selected[group].forEach(function (value) {
        var option = findOption(section, group, value);
        var label = option ? labelFor(option) : value;
        addChip(chipsRow, label, function () { removeFilter(section, group, value); });
      });
    });

    if (priceNarrowed) {
      /* Espaces insécables autour du « à », comme le rendu Liquid des bornes
         (&#160;) : le chip ne doit jamais se couper entre un prix et le mot. */
      var priceLabel = formatPrice(state.priceMin, state.currencySymbol) + ' à ' + formatPrice(state.priceMax, state.currencySymbol);
      addChip(chipsRow, priceLabel, function () { resetPriceFilter(section); });
    }

    var clearAll = document.createElement('div');
    clearAll.className = 'shop-chip is-clear-all';
    clearAll.setAttribute('role', 'button');
    clearAll.setAttribute('tabindex', '0');
    clearAll.textContent = section.getAttribute('data-clear-label') || 'tout effacer';
    clearAll.addEventListener('click', function () { clearAllFilters(section); });
    clearAll.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); clearAllFilters(section); }
    });
    chipsRow.appendChild(clearAll);
  }

  function addChip(row, label, onRemove) {
    var chip = document.createElement('div');
    chip.className = 'shop-chip';
    var txt = document.createElement('span');
    txt.textContent = label;
    var x = document.createElement('span');
    x.className = 'shop-chip-remove';
    x.setAttribute('role', 'button');
    x.setAttribute('tabindex', '0');
    x.setAttribute('aria-label', 'Retirer ce filtre');
    x.textContent = '×';
    x.addEventListener('click', onRemove);
    x.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onRemove(); }
    });
    chip.appendChild(txt);
    chip.appendChild(x);
    row.appendChild(chip);
  }

  function removeFilter(section, group, value) {
    var state = getState(section);
    var list = state.selected[group];
    var idx = list.indexOf(value);
    if (idx !== -1) list.splice(idx, 1);
    var option = findOption(section, group, value);
    if (option) { option.classList.remove('is-checked'); option.setAttribute('aria-selected', 'false'); }
    render(section);
  }

  function clearAllFilters(section) {
    var state = getState(section);
    ['categorie'].concat(state.optionGroups).forEach(function (group) {
      state.selected[group] = [];
      section.querySelectorAll('.shop-dropdown[data-dropdown="' + group + '"] .shop-dropdown-option').forEach(function (opt) {
        opt.classList.remove('is-checked');
        opt.setAttribute('aria-selected', 'false');
      });
    });
    /* "Tout effacer" remet aussi la jauge Prix à ses bornes (retour Murat
       du 21/08). */
    state.priceMin = state.priceBoundsMin;
    state.priceMax = state.priceBoundsMax;
    render(section);
  }

  /* --- Délégation globale : un seul jeu de listeners, jamais reperdu
     (aucune carte n'est jamais recréée : elles existent toutes dès le
     rendu serveur, seul `hidden` bascule au filtrage). ------------------- */

  document.addEventListener('click', function (e) {
    var section = e.target.closest('[data-collection-catalog]');
    if (!section) {
      document.querySelectorAll('[data-collection-catalog]').forEach(closeAllDropdowns);
      return;
    }

    if (e.target.closest('[data-filters-toggle]')) { openFiltersPanel(section); return; }
    if (e.target.closest('[data-filters-close]') || e.target.closest('[data-filters-backdrop]') || e.target.closest('[data-filters-apply]')) {
      closeFiltersPanel(section);
      return;
    }

    var option = e.target.closest('.shop-dropdown-option');
    if (option) {
      var dropdown = option.closest('.shop-dropdown');
      var group = dropdown ? dropdown.getAttribute('data-dropdown') : null;
      if (group === 'tri') {
        selectSort(section, option);
        closeAllDropdowns(section);
      } else if (group) {
        toggleCheckbox(section, group, option);
      }
      return;
    }

    if (e.target.closest('[data-clear-filters-empty]')) {
      clearAllFilters(section);
      return;
    }

    var filterItem = e.target.closest('.filter-item');
    if (filterItem && section.contains(filterItem)) {
      if (!e.target.closest('.shop-dropdown')) {
        openDropdown(filterItem);
      }
      return;
    }

    closeAllDropdowns(section);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-collection-catalog]').forEach(function (section) {
        closeAllDropdowns(section);
        closeFiltersPanel(section);
      });
      return;
    }
    if (e.key !== 'Enter' && e.key !== ' ') return;

    var option = e.target.closest('.shop-dropdown-option');
    if (option) {
      e.preventDefault();
      var section = option.closest('[data-collection-catalog]');
      var dropdown = option.closest('.shop-dropdown');
      var group = dropdown ? dropdown.getAttribute('data-dropdown') : null;
      if (!section || !group) return;
      if (group === 'tri') { selectSort(section, option); closeAllDropdowns(section); }
      else { toggleCheckbox(section, group, option); }
      return;
    }

    var filterItem = e.target.closest('.filter-item');
    if (filterItem && !e.target.closest('.shop-dropdown')) {
      e.preventDefault();
      openDropdown(filterItem);
    }
  });

  /* Jauge Prix : événement `input` (déplacement en direct, pas seulement au
     relâchement) sur les deux <input type="range">, délégué comme le reste
     (aucun re-attachement nécessaire après un shopify:section:load qui
     recrée la section : `input` remonte jusqu'à `document`). */
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-price-input]');
    if (!input) return;
    var section = input.closest('[data-collection-catalog]');
    if (!section) return;
    handlePriceInput(section, input);
  });

  /* RETOUR MURAT (03/09) : champs Prix éditables. `change` (perte de focus
     ou Entrée), pas `input`, pour ne pas relancer le filtre à chaque
     chiffre tapé. */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-price-number]');
    if (!input) return;
    var section = input.closest('[data-collection-catalog]');
    if (!section) return;
    handlePriceNumberInput(section, input);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-price-number]');
    if (!input) return;
    e.preventDefault();
    input.blur();
  });

  /* CORRECTION relecture : plus d'empilement au pointerdown/focusin. Il ne
     servait à rien (on ne peut appuyer que sur la poignée déjà au-dessus) et
     il entrait en conflit avec l'empilement positionnel de syncPriceUI, qui
     lui règle vraiment le blocage des deux poignées au plafond. */

  function init() {
    document.querySelectorAll('[data-collection-catalog]').forEach(function (section) {
      /* La section a pu être re-rendue par l'éditeur de thème (nouvelles
         cartes, nouveaux dropdowns) : on repart d'un état neuf plutôt que
         de garder des références obsolètes. */
      section._odaCatalog = null;
      render(section);
      /* Panneau mobile toujours refermé après un rendu (initial ou
         shopify:section:load) : jamais rouvert dans un état incohérent si
         l'éditeur recrée la section pendant qu'il était ouvert. */
      var panel = section.querySelector('[data-filters-panel]');
      if (panel && panel.classList.contains('is-open')) closeFiltersPanel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Accordéon FAQ EXCLUSIF, identique à product-faq.liquid : scope racine
     ".section-faq-collection" pour ne jamais matcher les mêmes éléments que
     le script de product-faq.liquid dans le bundle JS commun (cf. commentaire
     Liquid en tête de fichier). */

  function collapse(answer) { answer.style.maxHeight = '0px'; answer.style.opacity = '0'; }
  function expand(answer) { answer.style.maxHeight = answer.scrollHeight + 'px'; answer.style.opacity = '1'; }

  function setIcon(item, open) {
    var icon = item.querySelector('.faq-item-icon');
    if (!icon || !icon.src) return;
    /* LOT D1 BIS (05/09) : badge circulaire <=991px (assets/base.css,
       .faq-list .faq-item-icon), meme correctif que product-faq.liquid
       (voir son commentaire, verbatim). */
    if (window.matchMedia('(max-width: 991px)').matches) {
      if (icon.src.indexOf('icon-faq-minus') !== -1) {
        icon.src = icon.src.replace('icon-faq-minus', 'icon-faq-plus');
      }
      return;
    }
    icon.src = open
      ? icon.src.replace('icon-faq-plus', 'icon-faq-minus')
      : icon.src.replace('icon-faq-minus', 'icon-faq-plus');
  }

  function setState(item, open) {
    var answer = item.querySelector('.faq-answer');
    var row = item.querySelector('.faq-item-question-row');
    item.classList.toggle('is-open', open);
    if (answer) { if (open) { expand(answer); } else { collapse(answer); } }
    setIcon(item, open);
    if (row) row.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function openExclusive(item) {
    if (item.classList.contains('is-open')) {
      setState(item, false);
      return;
    }
    var list = item.closest('.faq-list') || document;
    list.querySelectorAll('.faq-item.is-open').forEach(function (other) {
      if (other !== item) setState(other, false);
    });
    setState(item, true);
  }

  function applyState() {
    document.querySelectorAll('.section-faq-collection .faq-list .faq-item').forEach(function (item) {
      var answer = item.querySelector('.faq-answer');
      var row = item.querySelector('.faq-item-question-row');
      if (!answer || !row) return;
      answer.style.overflow = 'hidden';
      answer.style.transition = 'max-height .3s ease, opacity .3s ease';
      var open = item.classList.contains('is-open');
      if (open) { expand(answer); } else { collapse(answer); }
      setIcon(item, open);
      /* LOT D1 BIS (05/09) : role/tabindex retires, le bouton natif porte
         deja ces semantiques (cf. markup Liquid). */
      row.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* LOT D1 BIS (05/09) : keydown dedie retire, un <button> natif declenche
     lui-meme un "click" sur Entree/Espace, meme correctif que product-faq.
     liquid (voir son commentaire, verbatim). */
  document.addEventListener('click', function (e) {
    var item = e.target.closest('.section-faq-collection .faq-list .faq-item');
    if (!item) return;
    if (e.target.closest('.faq-answer')) return;
    openExclusive(item);
  });

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll('.section-faq-collection .faq-item.is-open .faq-answer').forEach(function (answer) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      });
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyState);
  } else {
    applyState();
  }
  document.addEventListener('shopify:section:load', applyState);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
/* Menus deroulants du footer (retour Murat 06/09) : ouvrir une rubrique
   referme les autres. Le composant partage (assets/theme.js) ne gere que la
   bascule d un bouton ; cet ecouteur, delegue et pose une seule fois, ajoute
   l exclusivite AU FOOTER SEULEMENT (les accordeons des pages gardent leur
   comportement independant). */
(function () {
  if (window.__odaFooterAccExclusive) return;
  window.__odaFooterAccExclusive = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.footer-links-column .oda-m-acc-btn');
    if (!btn) return;
    if (window.matchMedia('(min-width: 768px)').matches) return;
    var wrapper = btn.closest('.footer-links-wrapper');
    if (!wrapper) return;
    wrapper.querySelectorAll('.oda-m-acc-btn').forEach(function (other) {
      if (other === btn) return;
      if (other.getAttribute('aria-expanded') !== 'true') return;
      other.setAttribute('aria-expanded', 'false');
      var lbl = other.querySelector('.oda-m-acc-label');
      var closed = other.getAttribute('data-label-closed');
      if (lbl && closed) lbl.textContent = closed;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-popups"]) return;
  try {
    
/* ECOUTEUR GENERIQUE D'ACHAT (07/09, lot "liens de paiement sur les pages de
   recuperation").
   La popup "adhesion" et son conteneur #sportigo-adhesion-container vivent
   dans CETTE section, rendue sur toutes les pages du site. Le petit script
   qui reporte les identifiants Sportigo du bouton clique vers ce conteneur,
   lui, n'existait qu'en COPIES LOCALES dans sections/page-tarifs-offres,
   page-tarifs-kids et page-testing-bilan : tout bouton d'achat pose ailleurs
   ouvrait donc la popup sur l'offre precedente, ou sur rien.
   Cette copie-ci est generique et vit avec le conteneur qu'elle pilote. La
   logique est identique aux copies locales, qui ne sont pas touchees : elles
   ont leur propre garde, s'attachent sur le meme evenement, ecrivent les
   memes valeurs depuis le meme bouton, et la comparaison ci-dessous rend
   l'ecriture idempotente (memes valeurs, aucun remontage). Aucune des deux ne
   depend de l'ordre dans lequel elles s'attachent.
   Convention des identifiants (correction Murat du 04/09, funnel tarifs) :
   data-offer-id = id du PLAN de paiement (fait ouvrir le widget directement
   sur l'ecran de commande), data-only-offer-id = id de l'OFFRE parente (seul
   vrai filtre du catalogue). Les deux ensemble sont indispensables des que
   l'offre distingue les deux ; sans le second, assets/sportigo-planning.js
   retombe sur le premier.
   Vider le conteneur et retirer data-mounted force le remontage du widget sur
   la nouvelle offre : le scan de assets/sportigo-planning.js repasse 250 ms
   apres chaque clic et remonte le conteneur devenu visible. */
(function () {
  if (window.__odaAdhesionOfferCta) return;
  window.__odaAdhesionOfferCta = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sportigo-adhesion-offer]');
    if (!btn) return;
    var offerId = (btn.getAttribute('data-sportigo-adhesion-offer') || '').trim();
    if (!offerId) return;
    var onlyOfferId = (btn.getAttribute('data-sportigo-adhesion-only-offer') || '').trim();
    var mount = document.getElementById('sportigo-adhesion-container');
    if (!mount) return;
    var curOffer = mount.getAttribute('data-offer-id');
    var curOnly = mount.getAttribute('data-only-offer-id') || '';
    if (curOffer !== offerId || curOnly !== onlyOfferId) {
      mount.setAttribute('data-offer-id', offerId);
      if (onlyOfferId) {
        mount.setAttribute('data-only-offer-id', onlyOfferId);
      } else {
        mount.removeAttribute('data-only-offer-id');
      }
      mount.removeAttribute('data-mounted');
      mount.innerHTML = '';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/* Tiroir mobile (retour Murat 06/09) : ouvrir une rubrique referme celle qui
   etait ouverte, pour que la navigation reste lisible d un coup d oeil. Le
   basculement lui-meme reste gere par assets/theme.js (data-nav-toggle) : cet
   ecouteur delegue ne fait que refermer les voisines, et seulement sous
   992 px (le mega menu PC n est pas concerne). */
(function () {
  if (window.__odaNavDrawerExclusive) return;
  window.__odaNavDrawerExclusive = true;
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    if (window.matchMedia('(min-width: 992px)').matches) return;
    var menu = toggle.closest('#nav-menu');
    if (!menu) return;
    window.requestAnimationFrame(function () {
      if (!toggle.classList.contains('is-open')) return;
      menu.querySelectorAll('[data-nav-toggle].is-open').forEach(function (other) {
        if (other !== toggle) other.classList.remove('is-open');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* 05/09 (Murat, point 58) : la vidéo de fond ne démarre pas sur mobile
     (Safari iPhone), seule la photo de repli (poster) s'affiche, alors que
     le <video> porte déjà tous les attributs HTML nécessaires (autoplay,
     muted, playsinline, loop, preload="auto", codec H.264 vérifié, moov en
     tête/faststart vérifié : la vidéo elle-même n'est pas en cause). Cause
     probable : l'attribut HTML `autoplay` seul est bloqué dans certains
     contextes iOS (mode Économie d'énergie notamment, Murat doit le
     confirmer sur son iPhone), alors qu'un appel SCRIPTÉ `video.play()`
     passe. Aucun tel appel n'existait avant ce correctif : ce bloc en
     ajoute un, systématiquement rejoué (idempotent, un play() sur une vidéo
     déjà lancée ne fait rien) à l'initialisation, à chaque changement de
     slide, au retour de visibilité de l'onglet et une fois au premier
     toucher (repli si l'autoplay a été refusé). Le son n'est jamais forcé
     (l'attribut muted n'est jamais retiré). */
  function tryPlayVideo(video) {
    if (!video) return;
    try {
      /* 07/09 (retour Murat : bouton lecture sur certains Mac) : Safari ne
         considere un <video> comme muet que si la propriete est posee au
         moment du play(), l attribut HTML ne suffit pas toujours (elements
         clones par Splide, restauration de page). Muet garanti, puis play(). */
      video.muted = true;
      video.defaultMuted = true;
      if (!video.paused) return;
      var p = video.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
    } catch (e) {}
  }
  /* Salves differees : sur Mac, l autoplay refuse au premier essai (page pas
     encore visible, media pas encore tamponne) passe souvent 1 a 4 s plus tard. */
  function scheduleHeroRetries(root) {
    [300, 1200, 3000, 6000].forEach(function (delay) {
      window.setTimeout(function () { playHeroVideos(root); }, delay);
    });
  }

  /* Vidéo(s) du/des slide(s) ACTIF(S) d'un hero donné. Splide (type "fade")
     pose la classe `is-active` sur le slide affiché (clone compris : si un
     jour le type passe à "loop", Splide pose la même classe sur les clones).
     Sans slider (un seul bloc Slide, pas de Splide monté), il n'y a qu'un
     `.hero-slide` : aucun n'est jamais marqué is-active, d'où le repli sur
     TOUS les `.hero-slide` trouvés dans ce cas précis (il n'y en a qu'un). */
  function playHeroVideos(heroEl) {
    var actives = heroEl.querySelectorAll('.hero-slide.is-active');
    if (actives.length === 0) {
      actives = heroEl.querySelectorAll('.hero-slide');
    }
    actives.forEach(function (slide) {
      var video = slide.querySelector('video.hero-background-video');
      if (!video) return;
      tryPlayVideo(video);
      if (video.readyState < 1) {
        video.addEventListener('loadedmetadata', function () { tryPlayVideo(video); }, { once: true });
      }
    });
  }

  function initOne(root) {
    /* Tentative immédiate, avant même de savoir si Splide doit se monter :
       couvre le cas 1 seul slide (pas de Splide) et sert de première salve
       pour le cas slider (rejouée juste après le mount ci-dessous). */
    playHeroVideos(root);
    scheduleHeroRetries(root);

    var el = root.querySelector('.hero-slider.splide');
    if (!el || el.dataset.odaHeroSplideMounted === '1') return;
    if (typeof Splide === 'undefined') {
      /* Cas ÉDITEUR DE THÈME (bug Murat 23/08) : quand on passe de 1 à 2+
         slides, la section est re-rendue et ses <script> injectés ne
         s'exécutent JAMAIS (comportement navigateur sur innerHTML) : Splide
         n'existe pas encore. On charge la lib dynamiquement (URL portée par
         data-splide-src : le bundle JS de section n'a pas acces a asset_url)
         puis on relance l'init une fois chargee. Garde anti-double-injection. */
      var src = el.getAttribute('data-splide-src');
      if (!src) return;
      if (!window.odaSplideLoading) {
        window.odaSplideLoading = true;
        var s = document.createElement('script');
        s.src = src;
        s.onload = init;
        document.head.appendChild(s);
      }
      return;
    }
    var interval = parseInt(el.getAttribute('data-autoplay-interval'), 10) || 6000;
    var autoplayOn = el.getAttribute('data-autoplay') === 'true';
    var splideInstance = new Splide(el, {
      type: 'fade',
      rewind: true,
      /* 05/09 (Murat, point 60) : swipe au doigt entre les slides. En type
         "fade" Splide ne fait pas suivre le doigt visuellement (pas de
         translation de piste, seulement l'opacité) mais détecte bien le
         geste et déclenche le changement de slide au franchissement du
         seuil, flickPower par défaut (raisonnable), non surchargé. */
      drag: true,
      arrows: false,
      pagination: true,
      /* Décoché par défaut (demande Yann 31/08) : le slider ne défile JAMAIS
         seul, la navigation manuelle par les puces reste possible. La vidéo
         de fond du slide actif continue de boucler nativement, indépendante
         de Splide. */
      autoplay: autoplayOn,
      interval: interval,
      pauseOnHover: true,
      pauseOnFocus: true,
      speed: 900
    });
    splideInstance.mount();
    el.dataset.odaHeroSplideMounted = '1';
    /* Le slide actif (is-active) n'existe qu'une fois Splide monté : rejoue
       ici pour cibler le bon <video> (pas seulement le repli "tous"
       ci-dessus). Puis à chaque changement de slide réel. */
    playHeroVideos(root);
    splideInstance.on('moved', function () { playHeroVideos(root); });
  }

  function init() {
    document.querySelectorAll('.section-hero').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Même filet d'ordre d'exécution que sections/home-seance.liquid : les
     scripts de section sont concaténés et chargés en async, potentiellement
     avant le defer de splide.min.js posé plus haut. */
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);

  /* Repli autoplay refusé (point 58) : retour de visibilité (l'utilisateur
     change d'onglet/d'app puis revient) et premier toucher de l'utilisateur
     (geste), une seule fois pour ce dernier. Portée globale (pas par hero) :
     posé une seule fois à l'évaluation du script, jamais dupliqué par les
     réinitialisations ci-dessus. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    document.querySelectorAll('.section-hero').forEach(playHeroVideos);
  });
  /* Premiere interaction, quelle qu elle soit (toucher, clic, molette,
     clavier) : Safari macOS autorise alors la lecture meme quand l autoplay
     etait bloque (reglage « Ne jamais lire automatiquement », economie
     d energie). */
  ['touchstart', 'pointerdown', 'click', 'wheel', 'keydown', 'scroll'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      document.querySelectorAll('.section-hero').forEach(playHeroVideos);
    }, { once: true, passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-seance"] && !Shopify.designMode) return;
  try {
    
(function () {
  function isMobile() {
    return window.innerWidth <= 767;
  }

  function wireArrows(root, splideInstance) {
    var prev = root.querySelector('.arrow.prev');
    var next = root.querySelector('.arrow.next');
    if (!prev || !next) return;
    var onPrev = function () { splideInstance.go('-1'); };
    var onNext = function () { splideInstance.go('+1'); };
    prev.addEventListener('click', onPrev);
    next.addEventListener('click', onNext);
    prev.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onPrev(); } });
    next.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onNext(); } });
  }

  function initOne(root) {
    var el = root.querySelector('.splide');
    if (!el || el.dataset.odaSplideMounted === '1') return;
    if (typeof Splide === 'undefined') return; // garde : script Splide pas encore exécuté
    var splideInstance = new Splide(el, {
      type: 'loop',
      autoWidth: true,
      height: 'auto',
      drag: 'free',
      snap: false,
      focus: 'start',
      arrows: false,
      pagination: false,
      waitForTransition: false,
      clones: isMobile() ? 3 : 5
    });
    splideInstance.mount();
    wireArrows(root, splideInstance);
    el.dataset.odaSplideMounted = '1';
  }

  function init() {
    document.querySelectorAll('.section-seance .seance-components').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Filet de sécurité sur l'ordre d'exécution : les blocs de script des
     sections sont concaténés par Shopify dans un scripts.js injecté par
     content_for_header (donc dans le head) et chargé en ASYNC : il peut donc
     s'exécuter AVANT le script defer de splide.min.js posé plus haut dans
     cette section. Dans ce cas init() sort sur la garde `typeof Splide` et,
     si readyState valait déjà 'interactive', aucun DOMContentLoaded n'est
     écouté : le slider ne se monterait jamais. `load` arrive après tous les
     defer ; initOne() est idempotent (dataset.odaSplideMounted). */
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Sommaire généré depuis les <h2> du corps (mécanique documentée par la spec
     §2.1 : items identiques aux h2 qu'ils ciblent, ancre = id du h2). Un vrai
     article Shopify ne pose jamais d'id sur ses titres -> on en génère un
     (slug accents supprimés) et on le pose sur le h2 lui-même si absent, pour
     que l'ancre #slug fonctionne réellement. */
  function slugify(text, used) {
    var base = (text || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    if (!base) base = 'section';
    var slug = base;
    var i = 2;
    while (used[slug]) {
      slug = base + '-' + i;
      i += 1;
    }
    used[slug] = true;
    return slug;
  }

  function buildSummary(root) {
    var card = root.querySelector('[data-summary-card]');
    var list = root.querySelector('[data-summary-list]');
    var body = root.querySelector('.article-body');
    if (!card || !list || !body) return;

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
    list.innerHTML = '';

    if (!headings.length) {
      card.hidden = true;
      return;
    }

    var used = {};
    headings.forEach(function (heading) {
      if (!heading.id) {
        heading.id = slugify(heading.textContent, used);
      } else {
        used[heading.id] = true;
      }
      var item = document.createElement('a');
      item.className = 'summary-item';
      item.href = '#' + heading.id;

      var dot = document.createElement('div');
      dot.className = 'summary-dot';

      var text = document.createElement('div');
      text.className = 'summary-text';
      text.textContent = heading.textContent;

      item.appendChild(dot);
      item.appendChild(text);
      list.appendChild(item);
    });

    card.hidden = false;
  }

  /* Partage social : JS verbatim spec §2.3 (facebook/linkedin/x en popup
     navigateur, copie de lien avec repli execCommand). Entièrement portable :
     window.location.href / document.title sont déjà les valeurs Shopify. */
  function shareUrl(kind) {
    var url = encodeURIComponent(window.location.href);
    var title = encodeURIComponent(document.title);
    if (kind === 'facebook') return 'https://www.facebook.com/sharer/sharer.php?u=' + url;
    if (kind === 'linkedin') return 'https://www.linkedin.com/sharing/share-offsite/?url=' + url;
    if (kind === 'x') return 'https://twitter.com/intent/tweet?url=' + url + '&text=' + title;
    return null;
  }

  function bindShare(root) {
    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-share]');
      if (!el || !root.contains(el)) return;
      e.preventDefault();
      var kind = el.getAttribute('data-share');
      if (kind === 'copy') {
        var url = window.location.href;
        var done = function () {
          var icon = el.querySelector('img');
          var prevTitle = el.getAttribute('aria-label');
          el.setAttribute('aria-label', 'Lien copié !');
          if (icon) icon.style.opacity = '0.4';
          setTimeout(function () {
            el.setAttribute('aria-label', prevTitle);
            if (icon) icon.style.opacity = '';
          }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (err) {}
          document.body.removeChild(ta);
          done();
        }
        return;
      }
      var target = shareUrl(kind);
      if (target) window.open(target, '_blank', 'noopener,noreferrer,width=600,height=500');
    });
  }

  function init() {
    document.querySelectorAll('.article-layout').forEach(function (root) {
      buildSummary(root);
      if (!root._odaShareBound) {
        root._odaShareBound = true;
        bindShare(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-a-propos"]) return;
  try {
    
/* Indicateur "Scroll" du hero : masqué en opacity dès 80px de défilement.
   Propre à cette page (aucune autre section n'a de .scroll-indicator). */
document.addEventListener('DOMContentLoaded', function () {
  var targets = document.querySelectorAll('.scroll-indicator');
  if (!targets.length) return;
  var THRESHOLD = 80;
  var hidden = false;
  function update() {
    var y = window.scrollY || window.pageYOffset || 0;
    var shouldHide = y > THRESHOLD;
    if (shouldHide === hidden) return;
    hidden = shouldHide;
    targets.forEach(function (el) {
      el.classList.toggle('oda-hero-hidden', shouldHide);
    });
  }
  update();
  window.addEventListener('scroll', update, { passive: true });
});

/* Carrousels Splide (Évolution + Équipe) : passe UX/UI mobile 01/09.
   NOTE : un seul bloc {% javascript %} par section est autorisé par
   Shopify (un 2e bloc lève "Duplicate entries for tag: javascript" au
   push, piège payé le 01/09) : regroupé ici avec le JS de l'indicateur
   scroll ci-dessus. Même lib/version/config que sections/page-kids-teens-
   ados.liquid ("Nos offres") : monté UNIQUEMENT si la largeur est
   <=767px, au-dessus
   .evolution-cards/.team-list restent pilotées par le flex-wrap CSS pur
   (2 colonnes tablette, inchangé). Idempotent (dataset.odaSplideMounted)
   : même filet que les autres sections Splide du thème, au cas où ce
   script s'exécute avant le defer de splide.min.js posé plus haut. */
(function () {
  function mount(el) {
    if (!el || el.dataset.odaSplideMounted === '1') return;
    if (typeof Splide === 'undefined') return;
    var splideInstance = new Splide(el, {
      type: 'loop',
      autoWidth: true,
      height: 'auto',
      drag: 'free',
      snap: false,
      focus: 'start',
      arrows: false,
      pagination: true,
      waitForTransition: false,
      clones: 3
    });
    splideInstance.mount();
    el.dataset.odaSplideMounted = '1';
  }

  function init() {
    if (window.innerWidth > 767) return;
    document.querySelectorAll('.evo-track .splide').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-arts-martiaux"]) return;
  try {
    
(function () {
  /* Tabs disciplines : tablist verticale accessible (flèches/Home/End/Entrée),
     un seul panneau affiché, 1er onglet actif par défaut, zoom photo au
     survol explicitement désactivé (demande client, spec A.7). Générique au
     nombre de blocs (chantier éditabilité : le compte n'est plus fixé à 5). */
  function initDisciplinesTabs() {
    var body = document.querySelector('.section-disciplines .disciplines-body');
    if (!body || body.dataset.odaTabsInit === '1') return;
    body.dataset.odaTabsInit = '1';
    var list = body.querySelector('.disciplines-list');
    var wrap = body.querySelector('.disciplines-panes');
    if (!list || !wrap) return;
    var tabs = [].slice.call(list.querySelectorAll('.discipline-item'));
    var lines = [].slice.call(list.querySelectorAll('.discipline-item-line'));
    var panes = [].slice.call(wrap.querySelectorAll('.discipline-pane'));
    if (tabs.length < 2 || panes.length !== tabs.length) return;
    /* CENTRAGE section coachs (05/09) : wrapper SIBLING de .disciplines-body
       (hors de la grille à 2 colonnes onglets/pane, cf. CSS/Liquid plus
       haut) : cherché au niveau du document, pas de `body`/`wrap` puisqu'il
       n'en est plus un descendant. Un panneau par discipline dans le MÊME
       ordre/nombre que `panes` (garanti par la boucle Liquid qui les
       construit), vérifié explicitement avant de piloter quoi que ce soit. */
    var coachsWrap = document.querySelector('.discipline-coachs-panes');
    var coachsPanes = coachsWrap ? [].slice.call(coachsWrap.querySelectorAll('.discipline-coachs-pane')) : [];
    var coachsInSync = coachsPanes.length === panes.length;
    list.setAttribute('role', 'tablist');
    list.setAttribute('aria-orientation', 'vertical');
    list.setAttribute('aria-label', 'Choisissez votre discipline');
    lines.forEach(function (l) { l.setAttribute('aria-hidden', 'true'); });
    tabs.forEach(function (t, i) {
      var ttl = t.querySelector('.discipline-item-title');
      var slug = 'discipline-arts-martiaux-' + (i + 1);
      t.setAttribute('role', 'tab');
      t.setAttribute('id', slug + '-tab');
      t.setAttribute('aria-controls', slug + '-panel');
      if (ttl) t.setAttribute('aria-label', ttl.textContent.trim());
      panes[i].setAttribute('role', 'tabpanel');
      panes[i].setAttribute('id', slug + '-panel');
      panes[i].setAttribute('aria-labelledby', slug + '-tab');
      panes[i].setAttribute('tabindex', '0');
    });
    function select(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (lines[k]) lines[k].classList.toggle('is-active', on);
        panes[k].classList.toggle('is-active', on);
        if (coachsInSync) coachsPanes[k].classList.toggle('is-active', on);
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        select(i, false);
        /* [audit mobile 05/09, tour 3, mineur 16] Defilement automatique
           retire : incoherent avec page-preparation-physique.liquid, meme
           composant partage, qui ne defile jamais et garde liste+volet
           visibles ensemble (juge plus lisible par l'audit, cf. registre) --
           les deux pages suivent desormais ce meme comportement. Ancien
           correctif (point 66, puis tour 2 constat 4) conserve en
           commentaire pour memoire : ciblait `t.scrollIntoView(...)` sous
           <=991px pour rappeler la discipline choisie apres le saut, mais
           creait un saut de defilement parasite absent de l'autre page. */
      });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowDown' || k === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (k === 'ArrowUp' || k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') n = 0;
        else if (k === 'End') n = tabs.length - 1;
        else if (k === 'Enter' || k === ' ') { e.preventDefault(); select(i, true); return; }
        if (n !== null) { e.preventDefault(); select(n, true); }
      });
    });
    wrap.classList.add('is-ready');
    if (coachsInSync) coachsWrap.classList.add('is-ready');
    select(0, false);
  }

  /* Widget Sportigo (planning 1502, dayList, thème sombre) : script fourni
     par Murat (spec C.2). widen() annule le max-width:1152px interne du
     widget en injectant une feuille dans son shadow root OUVERT. Cible
     l'identifiant fixe #sportigo-appointment-container : ne s'active donc
     que si le champ "Code d'intégration Sportigo" est vide (comportement
     par défaut, inchangé). */
  function initSportigo() {
    var el = document.getElementById('sportigo-appointment-container');
    if (!el || el.dataset.odaSportigoInit === '1') return;
    if (typeof window.initComponent !== 'function') return;
    el.dataset.odaSportigoInit = '1';
    window.initComponent('Appointment', 'sportigo-appointment-container', 'deabca95-e2b2-4217-88b8-5647f6c33428', {
      theme: { dark: true },
      readonly: false,
      forceBookBtn: false,
      colored: true,
      planning: 1502,
      displayMode: 'dayList'
    });
    function widen() {
      var q = document.querySelector('#sportigo-appointment-container .quote');
      var sr = q && q.shadowRoot;
      if (!sr) return false;
      if (!sr.querySelector('style[data-oda-wide]')) {
        var st = document.createElement('style');
        st.setAttribute('data-oda-wide', '1');
        st.textContent = '.max-w-6xl{max-width:none!important}';
        sr.appendChild(st);
      }
      return true;
    }
    var tries = 0;
    var iv = setInterval(function () { if (widen() || ++tries > 80) { clearInterval(iv); } }, 250);
  }
  function loadSportigoScript() {
    if (window.initComponent || document.querySelector('script[data-oda-sportigo]')) { initSportigo(); return; }
    var s = document.createElement('script');
    s.src = 'https://standalone.api.sportigo.fr/component-standalone.js';
    s.setAttribute('data-oda-sportigo', '1');
    s.addEventListener('load', initSportigo);
    document.body.appendChild(s);
  }

  function init() {
    initDisciplinesTabs();
    loadSportigoScript();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-coaching-plus-combat"]) return;
  try {
    
(function () {
  /* Tabs disciplines : RETOUCHE 03/09, dupliqué de page-arts-martiaux.liquid
     (tablist verticale accessible : flèches/Home/End/Entrée, un seul panneau
     affiché, 1er onglet actif par défaut). Sélecteur SCOPÉ à
     `.section-cpc-disciplines` (propre à cette page, fichier auto-suffisant,
     remplace l'init Splide retiré). */
  function initCpcDisciplinesTabs() {
    var body = document.querySelector('.section-cpc-disciplines .disciplines-body');
    if (!body || body.dataset.odaTabsInit === '1') return;
    body.dataset.odaTabsInit = '1';
    var list = body.querySelector('.disciplines-list');
    var wrap = body.querySelector('.disciplines-panes');
    if (!list || !wrap) return;
    var tabs = [].slice.call(list.querySelectorAll('.discipline-item'));
    var lines = [].slice.call(list.querySelectorAll('.discipline-item-line'));
    var panes = [].slice.call(wrap.querySelectorAll('.discipline-pane'));
    if (tabs.length < 2 || panes.length !== tabs.length) return;
    list.setAttribute('role', 'tablist');
    list.setAttribute('aria-orientation', 'vertical');
    list.setAttribute('aria-label', 'Choisissez votre discipline');
    lines.forEach(function (l) { l.setAttribute('aria-hidden', 'true'); });
    tabs.forEach(function (t, i) {
      var ttl = t.querySelector('.discipline-item-title');
      var slug = 'discipline-cpc-' + (i + 1);
      t.setAttribute('role', 'tab');
      t.setAttribute('id', slug + '-tab');
      t.setAttribute('aria-controls', slug + '-panel');
      if (ttl) t.setAttribute('aria-label', ttl.textContent.trim());
      panes[i].setAttribute('role', 'tabpanel');
      panes[i].setAttribute('id', slug + '-panel');
      panes[i].setAttribute('aria-labelledby', slug + '-tab');
      panes[i].setAttribute('tabindex', '0');
    });
    function select(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (lines[k]) lines[k].classList.toggle('is-active', on);
        panes[k].classList.toggle('is-active', on);
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowDown' || k === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (k === 'ArrowUp' || k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') n = 0;
        else if (k === 'End') n = tabs.length - 1;
        else if (k === 'Enter' || k === ' ') { e.preventDefault(); select(i, true); return; }
        if (n !== null) { e.preventDefault(); select(n, true); }
      });
    });
    wrap.classList.add('is-ready');
    select(0, false);
  }

  function init() {
    initCpcDisciplinesTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-coaching-prive"]) return;
  try {
    
(function () {
  /* Cartes "formats" -> présélection du radio correspondant dans le
     formulaire plus bas (spec C.2). data-format reste un identifiant
     technique en dur, générique au nombre de blocs. */
  function initFormatCards() {
    document.querySelectorAll('.section-formats [data-format]').forEach(function (btn) {
      if (btn.dataset.odaFormatInit === '1') return;
      btn.dataset.odaFormatInit = '1';
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-format');
        var input = document.getElementById('format-' + val);
        if (input) { input.checked = true; }
      });
    });
  }
  function init() { initFormatCards(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  function syncHiddenName(section) {
    var prenom = section.querySelector('#ContactFormPrenom');
    var nom = section.querySelector('#ContactFormNom');
    var hidden = section.querySelector('#ContactFormNameHidden');
    if (!prenom || !nom || !hidden) return;
    function update() {
      hidden.value = (prenom.value + ' ' + nom.value).trim();
    }
    prenom.addEventListener('input', update);
    nom.addEventListener('input', update);
    update();
  }

  /* Carte Leaflet - Odyssée Academy. Coordonnées et zoom posés en data-
     attributes par Liquid (réglages de section, cf. tête de fichier) : un
     bloc JavaScript de section n'accepte aucune variable Liquid. Assets
     auto-hébergés (assets/leaflet.min.js / leaflet.min.css, jamais unpkg),
     injectés au premier besoin réel (IntersectionObserver) pour ne pas peser
     sur le chargement de la page. 100% décorative : zoom, molette, drag,
     double-clic et pincement désactivés : seul le bouton "voir l'itinéraire"
     de la pop-up de localisation partagée (système site-wide, hors périmètre
     de cette section) ouvre un vrai Google Maps dans un nouvel onglet. */
  var leafletPromise = null;
  function loadLeaflet(el) {
    if (window.L) return Promise.resolve();
    if (leafletPromise) return leafletPromise;
    leafletPromise = new Promise(function (resolve, reject) {
      var cssHref = el.getAttribute('data-leaflet-css');
      var jsSrc = el.getAttribute('data-leaflet-js');
      if (!cssHref || !jsSrc) { reject(new Error('leaflet-assets-missing')); return; }
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssHref;
      document.head.appendChild(link);
      var script = document.createElement('script');
      script.src = jsSrc;
      script.onload = function () { resolve(); };
      script.onerror = function () { reject(new Error('leaflet-load-failed')); };
      document.head.appendChild(script);
    });
    return leafletPromise;
  }

  function initMap(el) {
    if (!el || el.dataset.mapInit || typeof window.L === 'undefined') return;
    el.dataset.mapInit = 'true';
    if (!el.style.position) el.style.position = 'relative';
    var lat = parseFloat(el.getAttribute('data-lat')) || 46.23156;
    var lng = parseFloat(el.getAttribute('data-lng')) || 7.35818;
    var zoom = parseInt(el.getAttribute('data-zoom'), 10) || 17;
    var map = window.L.map(el, {
      center: [lat, lng],
      zoom: zoom,
      zoomControl: false,
      scrollWheelZoom: false,
      dragging: false,
      doubleClickZoom: false,
      touchZoom: false,
      boxZoom: false,
      keyboard: false,
      attributionControl: false
    });
    window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19
    }).addTo(map);
    var attribEl = document.createElement('div');
    attribEl.className = 'oda-map-attrib';
    attribEl.innerHTML = '&copy; OpenStreetMap';
    el.appendChild(attribEl);
    var pinSvg = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">'
      + '<path fill-rule="evenodd" fill="currentColor" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM12 11.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>'
      + '</svg>';
    var icon = window.L.divIcon({
      className: 'oda-map-marker-wrap',
      html: '<div class="oda-map-marker">' + pinSvg + '</div>',
      iconSize: [48, 48],
      iconAnchor: [24, 45]
    });
    window.L.marker([lat, lng], { icon: icon }).addTo(map);
    window.setTimeout(function () { map.invalidateSize(); }, 250);
  }

  function initMapLazy(section) {
    var el = section.querySelector('[data-map-canvas]');
    if (!el || el.dataset.mapObserved) return;
    el.dataset.mapObserved = 'true';
    function boot() { loadLeaflet(el).then(function () { initMap(el); }); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { boot(); io.disconnect(); }
        });
      }, { rootMargin: '200px' });
      io.observe(el);
    } else {
      boot();
    }
  }

  function init() {
    var section = document.querySelector('.section-contact');
    if (!section) return;
    syncHiddenName(section);
    initMapLazy(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-espace-recuperation"]) return;
  try {
    
(function () {
  /* Carrousel Splide de la galerie hero (même lib/version/config que
     sections/page-kids-teens-ados.liquid) monté UNIQUEMENT si la largeur
     est <=767px : au-dessus, `.hero-gallery.splide__list` reste piloté
     par CSS pur (flex row de 3 photos, inchangée). Idempotent (dataset.
     odaSplideMounted) : filet au cas où le script de section s'exécute
     avant le defer de splide.min.js posé plus haut. */
  function initOne(root) {
    if (window.innerWidth > 767) return;
    var el = root.querySelector('.splide');
    if (!el || el.dataset.odaSplideMounted === '1') return;
    if (typeof Splide === 'undefined') return;
    var splideInstance = new Splide(el, {
      type: 'loop',
      autoWidth: true,
      height: 'auto',
      drag: 'free',
      snap: false,
      focus: 'start',
      arrows: false,
      pagination: true,
      waitForTransition: false,
      clones: 3
    });
    splideInstance.mount();
    el.dataset.odaSplideMounted = '1';
  }

  function init() {
    document.querySelectorAll('.section-recovering-hero .hero-gallery-track').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-evenements"]) return;
  try {
    
(function () {
  if (document.documentElement.dataset.pastLoadMoreGuard) return;
  document.documentElement.dataset.pastLoadMoreGuard = '1';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-past-load-more]');
    if (!btn) return;
    var grid = btn.closest('.section-past-evenements').querySelector('.past-grid');
    grid.querySelectorAll('.past-card.is-extra').forEach(function (c) { c.classList.remove('is-extra'); });
    btn.closest('.past-load-more-row').style.display = 'none';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-kids-teens-ados"]) return;
  try {
    
(function () {
  /* Carrousel Splide (même lib/version/config que sections/home-seance.
     liquid et page-coaching-plus-combat.liquid) monté UNIQUEMENT si la
     largeur est <=767px : au-dessus, `.cours-grid.cours-grid-seniors`
     reste piloté par CSS pur (grid 5 colonnes desktop, flex-wrap 2
     colonnes tablette). Idempotent (dataset.odaSplideMounted) : même
     filet que les 2 autres sections, au cas où le script de section
     s'exécute avant le defer de splide.min.js posé plus haut. */
  function initOne(root) {
    /* RETOUCHE 05/09 (point 73) : carrousel Splide desactive -- "Nos
       offres" repasse en liste verticale sur mobile (demande Murat),
       Splide ne doit donc plus jamais se monter. Fonction conservee
       (inchangee sinon) pour reactivation facile si besoin plus tard. */
    return;
    if (window.innerWidth > 767) return;
    var el = root.querySelector('.splide');
    if (!el || el.dataset.odaSplideMounted === '1') return;
    if (typeof Splide === 'undefined') return;
    var splideInstance = new Splide(el, {
      type: 'loop',
      autoWidth: true,
      height: 'auto',
      drag: 'free',
      snap: false,
      focus: 'start',
      arrows: false,
      pagination: true,
      waitForTransition: false,
      clones: 3
    });
    splideInstance.mount();
    el.dataset.odaSplideMounted = '1';
  }

  function init() {
    document.querySelectorAll('.section-cours .cours-track').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-preparation-physique"]) return;
  try {
    
(function () {
  /* Tabs disciplines : identique arts-martiaux (spec A.7), verbatim, générique
     au nombre de blocs. */
  function initDisciplinesTabs() {
    var body = document.querySelector('.section-disciplines .disciplines-body');
    if (!body || body.dataset.odaTabsInit === '1') return;
    body.dataset.odaTabsInit = '1';
    var list = body.querySelector('.disciplines-list');
    var wrap = body.querySelector('.disciplines-panes');
    if (!list || !wrap) return;
    var tabs = [].slice.call(list.querySelectorAll('.discipline-item'));
    var lines = [].slice.call(list.querySelectorAll('.discipline-item-line'));
    var panes = [].slice.call(wrap.querySelectorAll('.discipline-pane'));
    if (tabs.length < 2 || panes.length !== tabs.length) return;
    list.setAttribute('role', 'tablist');
    list.setAttribute('aria-orientation', 'vertical');
    list.setAttribute('aria-label', 'Choisissez votre discipline');
    lines.forEach(function (l) { l.setAttribute('aria-hidden', 'true'); });
    tabs.forEach(function (t, i) {
      var ttl = t.querySelector('.discipline-item-title');
      var slug = 'discipline-preparation-physique-' + (i + 1);
      t.setAttribute('role', 'tab');
      t.setAttribute('id', slug + '-tab');
      t.setAttribute('aria-controls', slug + '-panel');
      if (ttl) t.setAttribute('aria-label', ttl.textContent.trim());
      panes[i].setAttribute('role', 'tabpanel');
      panes[i].setAttribute('id', slug + '-panel');
      panes[i].setAttribute('aria-labelledby', slug + '-tab');
      panes[i].setAttribute('tabindex', '0');
    });
    function select(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (lines[k]) lines[k].classList.toggle('is-active', on);
        panes[k].classList.toggle('is-active', on);
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowDown' || k === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (k === 'ArrowUp' || k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') n = 0;
        else if (k === 'End') n = tabs.length - 1;
        else if (k === 'Enter' || k === ' ') { e.preventDefault(); select(i, true); return; }
        if (n !== null) { e.preventDefault(); select(n, true); }
      });
    });
    wrap.classList.add('is-ready');
    select(0, false);
  }

  /* Countdown : RETOUR MURAT (05/09, 17e serie pt 89) : le JS scroll-driven
     vit desormais dans assets/theme.js (initCountdownSections(), bundle
     partage) puisque la section est un snippet reutilise sur 4 pages. Plus
     de copie locale ici. */

  function init() {
    initDisciplinesTabs();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-sponsors"]) return;
  try {
    
/* Champ natif contact[name] : Shopify ne reconnaît que name/email/phone/body.
   Le formulaire affiche Prénom et Nom séparément (maquette) : on recompose le
   champ caché à la volée, même mécanique que page-contact.liquid. */
(function () {
  function syncHiddenName(root) {
    var prenom = root.querySelector('#SponsorPrenom');
    var nom = root.querySelector('#SponsorNom');
    var hidden = root.querySelector('#SponsorNameHidden');
    if (!prenom || !nom || !hidden) return;
    function update() { hidden.value = (prenom.value + ' ' + nom.value).trim(); }
    prenom.addEventListener('input', update);
    nom.addEventListener('input', update);
    update();
  }
  function initName() { syncHiddenName(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initName);
  } else {
    initName();
  }
  document.addEventListener('shopify:section:load', initName);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-tarifs-kids"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (document.documentElement.dataset.emptyLinkGuard) return;
  document.documentElement.dataset.emptyLinkGuard = '1';
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-empty-link]');
    if (a) e.preventDefault();
  });
})();
/* Cartes Kids/Teens/Ados (04/09, correction Murat + revue Opus point 6) :
   memes ids Sportigo que le funnel (offre a un seul plan de paiement, id
   generique). Section identique a page-tarifs-offres.liquid, chaque
   section reste autonome (meme garde, un seul ecouteur attache meme si les
   deux scripts sont presents sur la meme page /pages/tarifs).
   CORRECTIF 04/09 soir (Pass Decouverte, page-tarifs-offres.liquid) :
   attribut optionnel data-sportigo-adhesion-only-offer ajoute pour les
   offres a PLUSIEURS plans de paiement (pose data-only-offer-id en plus de
   data-offer-id, meme mecanisme a deux ids que sections/tarifs-funnel.
   liquid, cf. _ref/SPORTIGO-OFFRES-04-09.md). Copie BYTE-IDENTIQUE de
   page-tarifs-offres.liquid : cette section est celle qui s'attache en
   premier sur /pages/tarifs (ordre du template : main, kids, offres), donc
   c'est CE script-ci qui gere reellement le clic sur Pass Decouverte :
   toute evolution de cette logique doit etre repercutee dans les deux
   fichiers a l'identique. Repli inchange pour les cartes Kids/Teens/Ados
   (offre a un seul plan) qui ne posent pas cet attribut. */
(function () {
  if (window.__odaTarifsOffresCta) return;
  window.__odaTarifsOffresCta = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sportigo-adhesion-offer]');
    if (!btn) return;
    var offerId = (btn.getAttribute('data-sportigo-adhesion-offer') || '').trim();
    if (!offerId) return;
    var onlyOfferId = (btn.getAttribute('data-sportigo-adhesion-only-offer') || '').trim();
    var mount = document.getElementById('sportigo-adhesion-container');
    if (!mount) return;
    var curOffer = mount.getAttribute('data-offer-id');
    var curOnly = mount.getAttribute('data-only-offer-id') || '';
    if (curOffer !== offerId || curOnly !== onlyOfferId) {
      mount.setAttribute('data-offer-id', offerId);
      if (onlyOfferId) {
        mount.setAttribute('data-only-offer-id', onlyOfferId);
      } else {
        mount.removeAttribute('data-only-offer-id');
      }
      mount.removeAttribute('data-mounted');
      mount.innerHTML = '';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-tarifs-offres"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (document.documentElement.dataset.emptyLinkGuard) return;
  document.documentElement.dataset.emptyLinkGuard = '1';
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-empty-link]');
    if (a) e.preventDefault();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-tarifs"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ------------------------------------------------------------------------
     Formatage devise unique (spec §3.0) : "CHF 119" en préfixe, milliers
     séparés par une espace fine U+202F, 2 décimales avec point UNIQUEMENT si
     elles sont non nulles (142.15 mais pas 119.00).
     ------------------------------------------------------------------------ */
  function fmtCHF(n) {
    var configSection = document.querySelector('.section-configurateur');
    var currency = (configSection && configSection.dataset.currencyLabel) || 'CHF';
    var rounded = Math.round(n * 100) / 100;
    var hasDecimals = Math.round(rounded * 100) % 100 !== 0;
    var parts = hasDecimals ? rounded.toFixed(2).split('.') : [String(Math.round(rounded))];
    var intPart = parts[0];
    var grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return currency + ' ' + grouped + (hasDecimals ? '.' + parts[1] : '');
  }

  /* Arrondi aux 5 centimes (équivalent mensuel), demande commerciale : un
     prix de type "142.13" ne se vend pas, "142.15" oui. */
  /* Libellé de discipline -> clé du funnel (repli quand le block n'a pas de
     « Clé dans le funnel ») : « Hybrid 360 (…) » -> hybride-360. */
  function cleDiscipline(t) {
    var k = String(t || '').replace(/\(.*$/, '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-');
    var alias = { 'hybrid-360': 'hybride-360', 'hybride360': 'hybride-360', 'hybrid360': 'hybride-360', 'grappling': 'grapple', 'jjb': 'grapple', 'calisthenie': 'calisthenics', 'calisthenie-s': 'calisthenics' };
    return alias[k] || k;
  }
  function arrondi5(n) {
    return Math.round(n * 20) / 20;
  }

  function initConfigurateur(section) {
    var dataScript = document.getElementById('tarifs-formules-' + section.dataset.sectionId);
    var formules = [];
    try { formules = dataScript ? JSON.parse(dataScript.textContent) : []; } catch (e) { formules = []; }

    var state = {
      univers: null,      // 'combat' | 'prepa' | 'both' | null
      etendue: null,       // 'focus' | 'unlimited' | 'choix' | null
      unlimited: false,    // bascule de l'étape 02 quand etendue === 'choix'
      discipline: { combat: null, prepa: null },
      modules: [],
      frequence: null   // clé (block.id, data-key) de la chip fréquence active : les 2 chips
                         // "Mensuel, engagement/sans engagement" partagent echeances == 12,
                         // data-key est donc la seule clé stable pour les distinguer (spec 26/08).
    };

    var modeGroup = section.querySelector('#config-step-univers .config-options');
    var moduleGroup = section.querySelector('#config-step-modules .config-options');
    var freqGroup = section.querySelector('#config-step-frequence .config-options');
    var groupCombat = section.querySelector('#critere-group-combat');
    var groupPrepa = section.querySelector('#critere-group-prepa');
    var allIncludedNote = section.querySelector('#config-all-included-note');

    function deriveFormule() {
      if (!state.univers) return null;
      var etendueEff = state.etendue === 'choix' ? (state.unlimited ? 'unlimited' : 'focus') : state.etendue;
      if (!etendueEff) return null;
      var key = state.univers + '-' + etendueEff;
      for (var i = 0; i < formules.length; i++) {
        if (formules[i].key === key) return formules[i];
      }
      return null;
    }

    function universSet() {
      if (state.univers === 'both') return { combat: true, prepa: true };
      var set = {};
      if (state.univers) set[state.univers] = true;
      return set;
    }

    function isEtendueUnlimited() {
      var f = deriveFormule();
      return !!f && f.etendue === 'unlimited';
    }

    function setMode(univers, etendue) {
      state.univers = univers;
      state.etendue = etendue;
      state.unlimited = etendue === 'unlimited';
      pruneState();
      render();
    }

    function setEtendueChoix(unlimited) {
      state.unlimited = unlimited;
      pruneState();
      render();
    }

    function setDiscipline(univers, blockId) {
      state.discipline[univers] = blockId || null;
      render();
    }

    function toggleModule(key, remplaceKeys) {
      var idx = state.modules.indexOf(key);
      if (idx > -1) {
        state.modules.splice(idx, 1);
      } else {
        /* Conflit `remplace` symétrique : sélectionner ce module désélectionne
           ceux qu'il remplace, et sélectionner l'un de ceux-ci désélectionne
           celui-ci en retour (spec §3.3). */
        state.modules = state.modules.filter(function (k) {
          if (remplaceKeys.indexOf(k) > -1) return false;
          var otherChip = moduleGroup.querySelector('.config-option[data-key="' + k + '"]');
          var otherRemplace = otherChip ? (otherChip.getAttribute('data-remplace') || '').split(',').map(function (s) { return s.trim(); }) : [];
          return otherRemplace.indexOf(key) === -1;
        });
        state.modules.push(key);
        /* Fusion (visio 26/08) : un module « pack » dont data-remplace liste 2+
           modules tous sélectionnés les fusionne automatiquement. */
        moduleGroup.querySelectorAll('.config-option').forEach(function (packChip) {
          var packKey = packChip.getAttribute('data-key');
          var rl = (packChip.getAttribute('data-remplace') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
          if (rl.length >= 2 && rl.every(function (k) { return state.modules.indexOf(k) > -1; })) {
            state.modules = state.modules.filter(function (k) { return rl.indexOf(k) === -1; });
            if (state.modules.indexOf(packKey) === -1) state.modules.push(packKey);
          }
        });
      }
      pruneState();
      render();
    }

    /* Sélection d'une chip fréquence par sa clé stable (block.id, data-key) :
       plus par echeances depuis le 26/08 : "Mensuel, engagement 12 mois" et
       "Mensuel, sans engagement" partagent echeances == 12 (spec 26/08). */
    function setFrequence(key) {
      var chipCliquee = freqGroup ? freqGroup.querySelector('.config-option[data-key="' + key + '"]') : null;
      if (chipCliquee && chipCliquee.classList.contains('is-disabled')) return;
      state.frequence = key;
      render();
    }

    /* Correctif préréglage (spec correctif §4.2) : les chips de l'étape 01
       portent data-etendue="choix" pour Combat/Prépa seuls (pas "focus"), donc
       chercher d'abord une chip (univers, étendue) EXACTE ; à défaut, se
       rabattre sur la chip (univers, "choix") puis piloter la bascule de
       l'étape 02 via setEtendueChoix. Sans quoi "composer cette formule" sur
       Focus ne sélectionnait aucune chip à l'étape 01 (setMode(univers,'focus')
       ne correspondait à aucune chip existante). */
    function applyPreset(univers, etendue) {
      var exactChip = modeGroup ? modeGroup.querySelector('.config-option[data-univers="' + univers + '"][data-etendue="' + etendue + '"]') : null;
      if (exactChip) {
        setMode(univers, etendue);
      } else {
        setMode(univers, 'choix');
        setEtendueChoix(etendue === 'unlimited');
      }
      var target = section.closest('.section-configurateur') || section;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* Retire les modules inéligibles (univers requis absent) ou désormais
       inclus dans la formule ; vide les disciplines hors formule ou quand
       l'étendue est "unlimited" (spec §3.3 pruneState). */
    function pruneState() {
      var f = deriveFormule();
      var uSet = universSet();
      state.modules = state.modules.filter(function (key) {
        var chip = moduleGroup.querySelector('.config-option[data-key="' + key + '"]');
        if (!chip) return false;
        var requiert = chip.getAttribute('data-requiert');
        if (requiert !== 'none' && !uSet[requiert]) return false;
        if (f && f.inclus.indexOf(key) > -1) return false;
        return true;
      });
      if (!uSet.combat || isEtendueUnlimited()) state.discipline.combat = null;
      if (!uSet.prepa || isEtendueUnlimited()) state.discipline.prepa = null;
    }

    function render() {
      var f = deriveFormule();
      var uSet = universSet();
      var unlimited = isEtendueUnlimited();

      /* Mise en avant (visio Yann 11/09) : message ponctuel associé à une
         discipline (ex. HYROX = compétition offerte), affiché dès son choix
         en formule Focus (jamais en Unlimited, jamais avant sélection),
         rappelé dans le récap. Lu depuis data-mise-en-avant de l'<option>
         choisie (state.discipline), donc éditable par Yann sans code en dur. */
      var miseEnAvantTexts = [];
      if (!unlimited) {
        ['combat', 'prepa'].forEach(function (u) {
          if (!uSet[u]) return;
          var blockId = state.discipline[u];
          if (!blockId) return;
          var sel = section.querySelector('#critere-select-' + u);
          var opt = sel ? sel.querySelector('option[value="' + blockId + '"]') : null;
          var msg = opt ? (opt.getAttribute('data-mise-en-avant') || '') : '';
          if (msg && miseEnAvantTexts.indexOf(msg) === -1) miseEnAvantTexts.push(msg);
        });
      }
      var miseEnAvantText = miseEnAvantTexts.join(' ');
      [section.querySelector('#config-mise-en-avant-el'), section.querySelector('#formule-mise-en-avant-el')].forEach(function (el) {
        if (!el) return;
        el.textContent = miseEnAvantText;
        el.classList.toggle('is-visible', !!miseEnAvantText);
      });

      /* Modules « annuel uniquement » (visio 26/08) : leur sélection force la
         fréquence annuelle, la note explicative s'affiche, et tout clic vers
         une autre fréquence retombe sur l'annuel tant qu'ils sont cochés. */
      var annualOnlyActive = false;
      moduleGroup.querySelectorAll('.config-option').forEach(function (chip) {
        if (chip.getAttribute('data-annuel-seulement') === 'true' && state.modules.indexOf(chip.getAttribute('data-key')) > -1) annualOnlyActive = true;
      });
      /* Précision Murat 02/09 : ces modules exigent un ENGAGEMENT SUR L'ANNÉE,
         pas l'annuel seul. Le mensuel avec engagement 12 mois reste donc
         disponible ; seule la chip « sans engagement » (majoration ou remise
         négative) est bloquée. Si elle était active, on bascule sur le mensuel
         engagé (même échéance), sinon sur l'annuel. */
      function chipSansEngagement(c) { return (parseFloat(c.getAttribute('data-majoration')) || 0) > 0 || (parseFloat(c.getAttribute('data-remise')) || 0) < 0; }
      if (freqGroup) {
        freqGroup.querySelectorAll('.config-option').forEach(function (c) {
          var off = annualOnlyActive && chipSansEngagement(c);
          c.classList.toggle('is-disabled', off);
          c.setAttribute('aria-disabled', off ? 'true' : 'false');
        });
      }
      if (annualOnlyActive) {
        var activeChip = freqGroup && state.frequence ? freqGroup.querySelector('.config-option[data-key="' + state.frequence + '"]') : null;
        if (!activeChip || chipSansEngagement(activeChip)) {
          var chips = freqGroup ? [].slice.call(freqGroup.querySelectorAll('.config-option')) : [];
          var engage = chips.filter(function (c) { return !chipSansEngagement(c) && c.getAttribute('data-echeances') === '12'; })[0];
          var annualChip = chips.filter(function (c) { return c.getAttribute('data-echeances') === '1'; })[0];
          var cible = engage || annualChip;
          if (cible) state.frequence = cible.getAttribute('data-key');
        }
      }
      var annualNoteEl = section.querySelector('#config-coaching-annual-note');
      if (annualNoteEl) annualNoteEl.style.display = annualOnlyActive ? '' : 'none';

      /* --- Étape 01 : chips mode --- */
      modeGroup.querySelectorAll('.config-option').forEach(function (chip) {
        var isActive = chip.getAttribute('data-univers') === state.univers &&
          (chip.getAttribute('data-etendue') === state.etendue);
        chip.classList.toggle('is-active', isActive);
        chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        /* Chip sans formule correspondante (spec correctif 13) : le couple
           (univers, étendue effective) n'a aucune formule dans le JSON.
           Pour etendue === 'choix' (pas d'étendue figée sur la chip), on
           teste le couple avec 'focus' (la formule la plus permissive). */
        var chipUnivers = chip.getAttribute('data-univers');
        var chipEtendue = chip.getAttribute('data-etendue');
        var etendueToTest = chipEtendue === 'choix' ? 'focus' : chipEtendue;
        var key = chipUnivers + '-' + etendueToTest;
        var hasFormule = formules.some(function (item) { return item.key === key; });
        chip.classList.toggle('is-unavailable', !hasFormule);
        if (hasFormule) {
          chip.removeAttribute('aria-disabled');
        } else {
          chip.setAttribute('aria-disabled', 'true');
        }
      });

      /* --- Étape 02 : bascule d'étendue (seulement si le mode est « au choix ») --- */
      var etendueRow = section.querySelector('#config-etendue-row');
      if (etendueRow) {
        etendueRow.classList.toggle('is-visible', state.etendue === 'choix');
        etendueRow.querySelectorAll('.config-option').forEach(function (chip) {
          var on = state.etendue === 'choix' && (chip.getAttribute('data-etendue-choice') === (state.unlimited ? 'unlimited' : 'focus'));
          chip.classList.toggle('is-active', on);
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      /* --- Étape 02 : dropdowns disciplines --- */
      [groupCombat, groupPrepa].forEach(function (group) {
        if (!group) return;
        var u = group.getAttribute('data-univers');
        var visible = !!uSet[u] && !unlimited;
        group.classList.toggle('is-visible', visible);
        /* Réinitialisation (spec correctif 4) : quand la discipline de cet
           univers est retombée à null (formule sans disciplines, mode
           unlimited, univers retiré...), on remet le <select>, le libellé
           affiché et les options du dropdown custom à leur état vide,
           sinon le dropdown gardait visuellement l'ancien choix. */
        if (!state.discipline[u]) {
          var select = group.querySelector('select');
          if (select) select.value = '';
          var label = group.querySelector('.critere-filter-label');
          if (label) label.textContent = group.getAttribute('data-placeholder') || '';
          group.querySelectorAll('.shop-dropdown-option.is-checked').forEach(function (opt) {
            opt.classList.remove('is-checked');
          });
        }
      });
      var anyUniversChosen = uSet.combat || uSet.prepa;
      if (allIncludedNote) {
        allIncludedNote.classList.toggle('is-visible', !!(anyUniversChosen && unlimited));
      }

      /* --- Étape 03 : chips modules --- */
      moduleGroup.querySelectorAll('.config-option').forEach(function (chip) {
        var key = chip.getAttribute('data-key');
        var requiert = chip.getAttribute('data-requiert');
        var eligible = requiert === 'none' || !!uSet[requiert];
        var included = !!(f && f.inclus.indexOf(key) > -1);
        var selected = state.modules.indexOf(key) > -1;
        chip.classList.toggle('is-hidden', !eligible);
        chip.classList.toggle('is-included', included);
        chip.classList.toggle('is-active', selected || included);
        chip.setAttribute('aria-pressed', (selected || included) ? 'true' : 'false');
      });

      /* --- Étape 04 : chips fréquence --- Sélection par clé stable (spec
         26/08) : les 3 options ("Mensuel, engagement 12 mois" / "Mensuel,
         sans engagement" / "Annuel, en une fois") sont désormais toutes au
         même niveau ; comme les deux premières partagent echeances == 12,
         seule data-key (block.id) les distingue de façon fiable. */
      var freqChips = [].slice.call(freqGroup.querySelectorAll('.config-option'));
      var activeFreqChip = null;
      freqChips.forEach(function (chip) {
        var isActive = state.frequence !== null && chip.getAttribute('data-key') === state.frequence;
        chip.classList.toggle('is-active', isActive);
        chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive) activeFreqChip = chip;
      });
      /* Sans fréquence sélectionnée, la 1re fréquence affichée sert de calcul
         (spec §3.3), sans pour autant l'activer visuellement. */
      var freqForCalc = activeFreqChip || freqChips[0] || null;
      /* Ex-sous-rangée "mensuel avec / sans engagement" (spec §4.4), aplatie
         en options principales le 26/08 : freqEffective reste un nom distinct
         (repris plus bas pour le calcul de prix) mais vaut désormais toujours
         la même chip que freqForCalc, il n'y a plus de second niveau. */
      var freqEffective = freqForCalc;
      /* Remise "sœur" : sur la chip "Mensuel, engagement" (remise 0), on va
         chercher la remise/majoration de l'AUTRE chip à la même echeances
         (la chip "Mensuel, sans engagement") pour calculer le barré / la
         ligne d'économie mensuelle. Sans effet sur "Annuel" : aucune autre
         chip ne partage son echeances == 1. */
      var remiseSoeur = 0;
      var majorationSoeur = 0;
      if (freqEffective) {
        var soeurChip = freqChips.filter(function (c) {
          return c !== freqEffective && c.getAttribute('data-echeances') === freqEffective.getAttribute('data-echeances');
        })[0];
        if (soeurChip) {
          remiseSoeur = parseFloat(soeurChip.getAttribute('data-remise')) || 0;
          majorationSoeur = parseFloat(soeurChip.getAttribute('data-majoration')) || 0;
        }
      }

      /* --- Calcul --- */
      var titleEl = section.querySelector('#formule-title-el');
      var disciplinesEl = section.querySelector('#formule-disciplines-el');
      var modulesEl = section.querySelector('#formule-modules-el');
      var priceOldEl = section.querySelector('#formule-price-old-el');
      var priceEl = section.querySelector('#formule-price-el');
      var unitEl = section.querySelector('#formule-price-unit-el');
      var subEl = section.querySelector('#formule-sub-label-el');
      var equivEl = section.querySelector('#formule-annual-equiv-el');
      var savingEl = section.querySelector('#formule-saving-el');
      var ctaEl = section.querySelector('#formule-cta-souscrire');

      var recapDisciplinesLabel = section.dataset.recapDisciplinesLabel;
      var recapModulesLabel = section.dataset.recapModulesLabel;
      var recapNoneLabel = section.dataset.recapNoneLabel;
      var recapAllLabel = section.dataset.recapAllLabel;
      var recapUndefinedLabel = section.dataset.recapUndefinedLabel;
      var includedLabel = section.dataset.includedLabel;
      var currencyLabel = section.dataset.currencyLabel;
      var equivTemplate = section.dataset.equivTemplate;
      var economieTemplate = section.dataset.economieTemplate;
      var economieMensuelleTemplate = section.dataset.economieMensuelleTemplate;

      if (!f) {
        /* Aucun univers choisi : titre vide + "dès CHF min(price)" (spec §3.3). */
        var minPrice = null;
        formules.forEach(function (item) {
          if (typeof item.price === 'number' && (minPrice === null || item.price < minPrice)) minPrice = item.price;
        });
        if (titleEl) titleEl.textContent = section.dataset.recapEmptyTitle;
        if (disciplinesEl) disciplinesEl.innerHTML = recapDisciplinesLabel + ' <span class="discipline-accent-red">' + recapUndefinedLabel + '</span>';
        if (modulesEl) modulesEl.innerHTML = recapModulesLabel + ' <span class="discipline-accent-red">' + recapNoneLabel + '</span>';
        if (priceOldEl) priceOldEl.classList.remove('is-visible');
        if (priceEl) {
          priceEl.classList.remove('is-discounted');
          priceEl.textContent = section.dataset.recapFromLabel + ' ' + (minPrice !== null ? fmtCHF(minPrice) : fmtCHF(0));
        }
        /* Repli d'unité (spec correctif 11) : plus de "/mois" en dur, on lit
           l'unit_label (data-unit) de la 1re fréquence affichée, comme le
           calcul de prix (freqForCalc) le fait déjà plus haut. */
        if (unitEl) unitEl.textContent = freqForCalc ? (freqForCalc.getAttribute('data-unit') || '') : '';
        if (subEl) subEl.textContent = section.dataset.recapEmptySub;
        if (equivEl) equivEl.classList.remove('is-visible');
        if (savingEl) savingEl.classList.remove('is-visible');
        if (ctaEl) { ctaEl.removeAttribute('data-booking'); ctaEl.setAttribute('href', '#'); ctaEl.setAttribute('data-empty-link', ''); ctaEl.removeAttribute('target'); ctaEl.removeAttribute('rel'); }
        return;
      }

      /* Disciplines choisies, pour titre + récap. */
      var discLabels = [];
      if (unlimited) {
        /* Visio 26/08 : « tous les univers » liste les disciplines incluses.
           01/09 : garde uSet ajouté : sans lui, « Combat Unlimited » listait
           aussi les disciplines de préparation physique (et réciproquement),
           alors que la référence Webflow ne liste que celles de SON univers.
           « Odyssée Unlimited » (les deux univers) liste toujours tout. */
        ['combat', 'prepa'].forEach(function (u) {
          if (!uSet[u]) return;
          var allSel = section.querySelector('#critere-select-' + u);
          if (!allSel) return;
          Array.prototype.forEach.call(allSel.options, function (opt) {
            if (opt.value && opt.getAttribute('data-hors-unlimited') !== 'true') discLabels.push(opt.textContent);
          });
        });
        if (!discLabels.length) discLabels.push(recapAllLabel);
      } else {
        ['combat', 'prepa'].forEach(function (u) {
          if (!uSet[u]) return;
          var select = section.querySelector('#critere-select-' + u);
          var blockId = state.discipline[u];
          if (blockId && select) {
            var opt = select.querySelector('option[value="' + blockId + '"]');
            if (opt) discLabels.push(opt.textContent);
          } else {
            discLabels.push(recapUndefinedLabel);
          }
        });
      }
      if (titleEl) titleEl.textContent = f.label;
      if (disciplinesEl) disciplinesEl.innerHTML = recapDisciplinesLabel + ' <span class="discipline-accent-red">' + (discLabels.length ? discLabels.join(' + ') : recapUndefinedLabel) + '</span>';

      /* Modules sélectionnés + inclus, pour le récap. */
      var modLabels = [];
      moduleGroup.querySelectorAll('.config-option').forEach(function (chip) {
        var key = chip.getAttribute('data-key');
        var included = f.inclus.indexOf(key) > -1;
        var selected = state.modules.indexOf(key) > -1;
        if (included || selected) {
          var label = chip.childNodes[0] ? chip.childNodes[0].textContent.trim() : chip.textContent.trim();
          modLabels.push(included ? label + ' (' + includedLabel + ')' : label);
        }
      });
      if (modulesEl) modulesEl.innerHTML = recapModulesLabel + ' <span class="discipline-accent-red">' + (modLabels.length ? modLabels.join(', ') : recapNoneLabel) + '</span>';

      /* --- Prix --- */
      var base = f.price;
      /* CHANGEMENT DE TARIF (Yann, 28/08) : une discipline peut porter son propre
         prix mensuel Focus (setting du block, rendu en data-prix-focus sur son
         <option>). Il remplace le prix de la formule « une discipline » de son
         univers ; tout le reste (sans engagement +20, annuel -10 %) en découle. */
      if (f.etendue === 'focus' && state.discipline[f.univers]) {
        var pfOpt = section.querySelector('#critere-select-' + f.univers + ' option[value="' + state.discipline[f.univers] + '"]');
        var pfVal = pfOpt ? parseFloat(pfOpt.getAttribute('data-prix-focus')) : NaN;
        if (!isNaN(pfVal)) base = pfVal;
      }
      var baseFormule = base;
      moduleGroup.querySelectorAll('.config-option').forEach(function (chip) {
        var key = chip.getAttribute('data-key');
        var included = f.inclus.indexOf(key) > -1;
        var selected = state.modules.indexOf(key) > -1;
        if (selected && !included) base += parseFloat(chip.getAttribute('data-price')) || 0;
      });
      var modulesMensuel = base - baseFormule;

      /* PRIX RÉELS SPORTIGO (revue du 02/09) : la formule SEULE est lue dans la
         table des 42 offres que le funnel d'adhésion rend sur chaque page
         (script #tarifs-funnel-offres-…, même source que le bouton Souscrire).
         Sportigo arrondit ses prix annuels (1 599 et non 149 × 12 − 10 % =
         1 609) : la table fait foi, le calcul reste le repli si l'offre n'y est
         pas. Les modules s'ajoutent à leur prix catalogue (× 12 à l'annuel,
         sans remise : c'est ce que Sportigo facture en option). */
      var offreReelle = null, offreEngagement = null, offreSans = null;
      (function () {
        if (!freqEffective) return;
        var tbl = window.__odaOffresFunnel;
        if (!tbl) {
          var sc = document.querySelector('script[id^="tarifs-funnel-offres"]');
          try { tbl = window.__odaOffresFunnel = sc ? JSON.parse(sc.textContent) : []; } catch (e) { tbl = window.__odaOffresFunnel = []; }
        }
        if (!tbl.length) return;
        var u = f.univers === 'both' ? (f.etendue === 'unlimited' ? 'tout' : 'combat-prepa') : f.univers;
        var et = f.univers === 'both' ? 'unique' : f.etendue;
        var d = 'na';
        if (et === 'focus') {
          var opt = section.querySelector('#critere-select-' + f.univers + ' option[value="' + state.discipline[f.univers] + '"]');
          if (!opt) return;
          d = opt.getAttribute('data-cle-funnel') || cleDiscipline(opt.textContent);
        }
        var ech = parseFloat(freqEffective.getAttribute('data-echeances')) || 12;
        var maj = parseFloat(freqEffective.getAttribute('data-majoration')) || 0;
        var rem = parseFloat(freqEffective.getAttribute('data-remise')) || 0;
        var fr = ech === 1 ? 'annuel' : ((maj > 0 || rem < 0) ? 'sans-engagement' : 'engagement12');
        function trouve(freq) {
          var cle = u + '__' + et + '__' + d + '__' + freq;
          for (var i = 0; i < tbl.length; i++) if (tbl[i].cle === cle && !isNaN(parseFloat(tbl[i].prix))) return tbl[i];
          return null;
        }
        offreReelle = trouve(fr); offreEngagement = trouve('engagement12'); offreSans = trouve('sans-engagement');
      })();

      var echeances = freqEffective ? (parseFloat(freqEffective.getAttribute('data-echeances')) || 12) : 12;
      var remisePct = freqEffective ? (parseFloat(freqEffective.getAttribute('data-remise')) || 0) : 0;
      var majorationChf = freqEffective ? (parseFloat(freqEffective.getAttribute('data-majoration')) || 0) : 0;
      var unit = freqEffective ? (freqEffective.getAttribute('data-unit') || '/mois') : '/mois';
      /* sub_label du récap (spec §4.4) : celui de la sous-option quand le
         mensuel avec/sans engagement est affiché, sinon celui de la fréquence
         principale (comportement §3.3 inchangé). */
      var sub = freqEffective ? (freqEffective.getAttribute('data-sub') || '') : '';
      var m = 12 / echeances;
      var plein = base * m;
      var r = remisePct / 100;
      var remise = Math.round(plein * (1 - r));
      if (offreReelle) {
        remise = Math.round(parseFloat(offreReelle.prix) + modulesMensuel * m);
        if (offreEngagement) plein = Math.round(parseFloat(offreEngagement.prix) * m + modulesMensuel * m);
      }
      var equiv = arrondi5(remise / m);
      var economiePerEcheance = plein - remise;
      var economieAnnuelle = economiePerEcheance * echeances;

      /* Cas ENGAGEMENT (spec §4.4, chips aplaties en principal le 26/08) : la
         chip active ("Mensuel, engagement") a une remise nulle alors que sa
         chip sœur ("Mensuel, sans engagement") porte une remise négative ou
         une majoration. Le prix affiché reste le prix de base (vert,
         is-discounted), le barré rouge devient le prix majoré de la sœur, et
         une ligne d'économie MENSUELLE (pas annuelle) s'affiche. */
      var rSoeur = remiseSoeur / 100;
      var isEngagementCase = r === 0 && majorationChf === 0 && (rSoeur < 0 || majorationSoeur > 0);
      /* Cas SANS ENGAGEMENT (spec §4.4) : remise négative ou majoration
         propre à la chip active elle-même ("Mensuel, sans engagement") ->
         prix majoré en argent, pas de barré, pas d'économie. */
      var isSansEngagementCase = (r < 0 || majorationChf > 0);

      if (isEngagementCase) {
        var barreEngagement = offreSans ? Math.round(parseFloat(offreSans.prix) + modulesMensuel) : (majorationSoeur > 0 ? Math.round(base + majorationSoeur) : Math.round(base * (1 - rSoeur)));
        var economieMensuelle = barreEngagement - remise;
        if (priceOldEl) {
          priceOldEl.textContent = fmtCHF(barreEngagement);
          priceOldEl.classList.add('is-visible');
          priceOldEl.classList.remove('is-markup');
        }
        if (priceEl) {
          priceEl.textContent = fmtCHF(remise);
          priceEl.classList.add('is-discounted');
        }
        if (unitEl) unitEl.textContent = unit;
        if (subEl) subEl.textContent = sub;
        if (equivEl) equivEl.classList.remove('is-visible');
        if (savingEl) {
          if (economieMensuelleTemplate) {
            savingEl.textContent = economieMensuelleTemplate.replace('{economie}', fmtCHF(economieMensuelle));
            savingEl.classList.add('is-visible');
          } else {
            savingEl.classList.remove('is-visible');
          }
        }
      } else if (isSansEngagementCase) {
        var majore = offreReelle ? remise : (majorationChf > 0 ? Math.round(base + majorationChf) : Math.round(base * (1 - r)));
        if (priceOldEl) { priceOldEl.classList.remove('is-visible'); priceOldEl.classList.remove('is-markup'); }
        if (priceEl) {
          priceEl.textContent = fmtCHF(majore);
          priceEl.classList.remove('is-discounted');
        }
        if (unitEl) unitEl.textContent = unit;
        if (subEl) subEl.textContent = sub;
        if (equivEl) equivEl.classList.remove('is-visible');
        if (savingEl) savingEl.classList.remove('is-visible');
      } else {
        /* Trimestriel / semestriel / annuel, et mensuel sans sous-rangée
           affichée : comportement §3.3 inchangé. */
        if (priceOldEl) {
          if (r !== 0) {
            /* r > 0 : remise, prix plein barré rouge (is-discounted sur le prix
               remisé passe en vert). r < 0 : majoration, le prix de référence
               affiché reste le prix engagé (non remisé), sans barré, en gris
               atténué (is-markup) : spec correctif 3. */
            priceOldEl.textContent = fmtCHF(plein);
            priceOldEl.classList.add('is-visible');
            priceOldEl.classList.toggle('is-markup', r < 0);
          } else {
            priceOldEl.classList.remove('is-visible');
            priceOldEl.classList.remove('is-markup');
          }
        }
        if (priceEl) {
          priceEl.textContent = fmtCHF(remise);
          priceEl.classList.toggle('is-discounted', r > 0);
        }
        if (unitEl) unitEl.textContent = unit;
        if (subEl) subEl.textContent = sub;

        if (equivEl) {
          if (m !== 1 && equivTemplate) {
            equivEl.textContent = equivTemplate.replace('{mensuel}', fmtCHF(equiv)).replace('{plein}', fmtCHF(base)).replace('{economie}', fmtCHF(economieAnnuelle));
            equivEl.classList.add('is-visible');
          } else {
            equivEl.classList.remove('is-visible');
          }
        }
        if (savingEl) {
          if (r > 0 && economieTemplate) {
            savingEl.textContent = economieTemplate.replace('{economie}', fmtCHF(economieAnnuelle)).replace('{mensuel}', fmtCHF(equiv)).replace('{plein}', fmtCHF(base));
            savingEl.classList.add('is-visible');
          } else {
            savingEl.classList.remove('is-visible');
          }
        }
      }

      if (ctaEl) {
        /* 01/09 (demande Murat) : « souscrire » ouvre désormais TOUJOURS le
           funnel d'adhésion en popup (sections/tarifs-funnel.liquid), qui a
           son propre parcours de questions indépendant de l'état de ce
           configurateur : remplace l'ancien branchement conditionnel
           (offre résolue ici / lien externe / bouton inactif) sur la popup
           "adhesion" de global-popups.liquid (laissée en place, inutilisée). */
        ctaEl.setAttribute('data-booking', 'tarifs');
        ctaEl.setAttribute('href', '#');
        ctaEl.removeAttribute('data-empty-link');
        ctaEl.removeAttribute('target');
        ctaEl.removeAttribute('rel');
      }
    }

    /* --- Écouteurs : étape 01 (mode) --- */
    if (modeGroup) {
      modeGroup.querySelectorAll('.config-option').forEach(function (chip) {
        function pick() {
          /* Chip sans formule correspondante (spec correctif 13) : clic ignoré. */
          if (chip.classList.contains('is-unavailable')) return;
          setMode(chip.getAttribute('data-univers'), chip.getAttribute('data-etendue'));
        }
        chip.setAttribute('role', 'button');
        chip.setAttribute('tabindex', '0');
        chip.addEventListener('click', pick);
        chip.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      });
    }

    /* --- Écouteurs : étape 02 (bascule d'étendue) --- */
    section.querySelectorAll('#config-etendue-row .config-option').forEach(function (chip) {
      function pick() { setEtendueChoix(chip.getAttribute('data-etendue-choice') === 'unlimited'); }
      chip.setAttribute('role', 'button');
      chip.setAttribute('tabindex', '0');
      chip.addEventListener('click', pick);
      chip.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
    });

    /* --- Écouteurs : étape 02 (disciplines), sur le <select> caché --- */
    ['combat', 'prepa'].forEach(function (u) {
      var select = section.querySelector('#critere-select-' + u);
      if (!select) return;
      select.addEventListener('change', function () { setDiscipline(u, select.value); });
    });

    /* --- Écouteurs : étape 03 (modules) --- */
    if (moduleGroup) {
      moduleGroup.querySelectorAll('.config-option').forEach(function (chip) {
        function pick() {
          if (chip.classList.contains('is-included') || chip.classList.contains('is-hidden')) return;
          var key = chip.getAttribute('data-key');
          var remplaceKeys = (chip.getAttribute('data-remplace') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
          toggleModule(key, remplaceKeys);
        }
        chip.setAttribute('role', 'button');
        chip.setAttribute('tabindex', '0');
        chip.addEventListener('click', pick);
        chip.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      });
    }

    /* --- Écouteurs : étape 04 (fréquence) --- Clé stable (data-key), pas
       echeances (spec 26/08, cf. commentaire sur setFrequence). */
    if (freqGroup) {
      freqGroup.querySelectorAll('.config-option').forEach(function (chip) {
        function pick() { setFrequence(chip.getAttribute('data-key')); }
        chip.setAttribute('role', 'button');
        chip.setAttribute('tabindex', '0');
        chip.addEventListener('click', pick);
        chip.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      });
    }

    /* --- CTA vide : neutralise le clic (spec §3.0) --- */
    var ctaEl = section.querySelector('#formule-cta-souscrire');
    if (ctaEl) {
      ctaEl.addEventListener('click', function (e) {
        if (ctaEl.hasAttribute('data-empty-link')) e.preventDefault();
      });
    }

    /* --- Cartes d'entrée : préréglage + scroll --- */
    document.querySelectorAll('.tarifs-entree-cta').forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyPreset(btn.getAttribute('data-preset-univers'), btn.getAttribute('data-preset-etendue'));
      });
    });

    render();
  }

  /* ==========================================================================
     Dropdowns disciplines : repris MOT POUR MOT de l'ancien fichier, seule
     adaptation : 2 groupes #critere-group-combat/#critere-group-prepa (au
     lieu de #critere-group-1/2), PLACEHOLDER et TRIGGER_LABEL lus sur
     data-placeholder du groupe (réglage `dropdown_placeholder`) au lieu
     d'être en dur.
     ========================================================================== */
  function initDropdowns(section) {
    var openPanel = null;

    function closeAll() {
      section.querySelectorAll('.critere-item .shop-dropdown.is-open').forEach(function (p) { p.classList.remove('is-open'); });
      section.querySelectorAll('.critere-item .filter-item.is-open').forEach(function (t) { t.classList.remove('is-open'); });
      openPanel = null;
    }

    function build(group) {
      if (!group) return;
      var PLACEHOLDER = group.getAttribute('data-placeholder') || 'à définir';
      var TRIGGER_LABEL = group.getAttribute('data-placeholder') || 'Choisir une discipline';
      var sel = group.querySelector('select');
      var trigger = group.querySelector('.filter-item');
      var label = group.querySelector('.critere-filter-label');
      if (!sel || !trigger || !label) return;
      if (!sel.querySelector('option[value=""]')) {
        var blank = document.createElement('option');
        blank.value = '';
        blank.textContent = PLACEHOLDER;
        sel.insertBefore(blank, sel.firstChild);
      }
      sel.value = '';
      label.textContent = TRIGGER_LABEL;
      var panel = document.createElement('div');
      panel.className = 'shop-dropdown';
      panel.setAttribute('role', 'listbox');
      [].slice.call(sel.options).forEach(function (o) {
        if (o.value === '') return;
        var item = document.createElement('div');
        item.className = 'shop-dropdown-option';
        item.setAttribute('data-value', o.value);
        item.setAttribute('role', 'option');
        item.setAttribute('tabindex', '0');
        var box = document.createElement('span');
        box.className = 'shop-dropdown-check';
        var txt = document.createElement('span');
        txt.textContent = o.textContent;
        item.appendChild(box);
        item.appendChild(txt);
        function choose(e) {
          if (e) e.stopPropagation();
          [].forEach.call(panel.querySelectorAll('.shop-dropdown-option'), function (x) { x.classList.remove('is-checked'); });
          item.classList.add('is-checked');
          label.textContent = o.textContent;
          sel.value = o.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          closeAll();
        }
        item.addEventListener('click', choose);
        item.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(e); } });
        panel.appendChild(item);
      });
      trigger.appendChild(panel);
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-haspopup', 'listbox');
      function toggle(e) {
        if (e) e.stopPropagation();
        var wasOpen = panel.classList.contains('is-open');
        closeAll();
        if (!wasOpen) { panel.classList.add('is-open'); trigger.classList.add('is-open'); openPanel = panel; }
      }
      trigger.addEventListener('click', toggle);
      trigger.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(e); } });
    }

    build(section.querySelector('#critere-group-combat'));
    build(section.querySelector('#critere-group-prepa'));
    document.addEventListener('click', function () { if (openPanel) closeAll(); });
    document.addEventListener('keydown', function (e) { if ((e.key === 'Escape' || e.key === 'Esc') && openPanel) closeAll(); });
  }

  function init() {
    var section = document.querySelector('.section-configurateur');
    if (!section || section.dataset.configuratorInit) return;
    section.dataset.configuratorInit = 'true';
    /* Ordre exact requis : le calcul de prix d'abord, les dropdowns custom
       ensuite (le second dépend du premier). */
    initConfigurateur(section);
    initDropdowns(section);
    /* Sélection par défaut (01/09, demande Murat) : première option de
       chaque étape obligatoire, pour qu'une formule et un prix s'affichent
       dès l'arrivée au lieu d'un récapitulatif vide. On passe par les clics
       réels pour que l'état, les chips et le libellé du menu déroulant
       restent cohérents. */
    var firstMode = section.querySelector('#config-step-univers .config-option');
    if (firstMode) firstMode.click();
    var firstDisc = section.querySelector('#critere-group-combat .shop-dropdown-option');
    if (firstDisc) firstDisc.click();
    var firstFreq = section.querySelector('#config-step-frequence .config-option');
    if (firstFreq) firstFreq.click();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* custom.specs_texte est du rich text : une ligne (un <p>) = une rangée
     « Label : Valeur ». On découpe sur le PREMIER « : », on trim (couvre
     l'espace fine U+202F que la typo française met avant les « : »), et on
     reconstruit les mêmes classes spec-row/spec-label/spec-value que
     l'ancien tableau piloté par metaobjects. Si le JS ne tourne pas, les
     paragraphes bruts (.spec-fallback) restent visibles et lisibles. */
  function buildSpecs(sourceEl) {
    var table = sourceEl.closest('.spec-table');
    if (!table) return;
    var rows = document.createDocumentFragment();
    var built = 0;
    sourceEl.querySelectorAll('p').forEach(function (p) {
      var text = (p.textContent || '').trim();
      if (!text) return;
      var sep = text.indexOf(':');
      if (sep === -1) return;
      var label = text.slice(0, sep).trim();
      var value = text.slice(sep + 1).trim();
      if (!label || !value) return;
      var row = document.createElement('div');
      row.className = 'spec-row';
      var labelEl = document.createElement('div');
      labelEl.className = 'spec-label';
      labelEl.textContent = label;
      var valueEl = document.createElement('div');
      valueEl.className = 'spec-value';
      valueEl.textContent = value;
      row.appendChild(labelEl);
      row.appendChild(valueEl);
      rows.appendChild(row);
      built += 1;
    });
    if (built === 0) return;
    table.insertBefore(rows, sourceEl);
    sourceEl.remove();
  }

  function init() {
    document.querySelectorAll('.section-boutique [data-specs-source]').forEach(buildSpecs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Accordéon FAQ EXCLUSIF (demande Murat 21/08, 2e passe) :
     - le premier item est ouvert au chargement (is-open posé par le Liquid) ;
     - une seule réponse visible à la fois : ouvrir un item enroule celui qui
       était ouvert ;
     - la bascule se fait au clic sur TOUTE la ligne (numéro fantôme, question,
       icône), pas seulement sur l'icône ; un clic DANS la réponse ne bascule
       rien (on peut sélectionner le texte, suivre un lien). */

  function collapse(answer) { answer.style.maxHeight = '0px'; answer.style.opacity = '0'; }
  function expand(answer) { answer.style.maxHeight = answer.scrollHeight + 'px'; answer.style.opacity = '1'; }

  function setIcon(item, open) {
    var icon = item.querySelector('.faq-item-icon');
    if (!icon || !icon.src) return;
    /* LOT D1 BIS (05/09) : badge circulaire <=991px (assets/base.css,
       .faq-list .faq-item-icon) -- un seul fichier icone (plus), la croix
       vient de la rotation CSS deja posee ici (.faq-item.is-open .faq-
       item-icon { transform: rotate(45deg) }, media 991 plus bas). Si
       l'icone Minus (un simple trait) etait laissee active a cette
       largeur, rotate(45deg) donnerait un tiret diagonal isole au lieu
       d'une croix -- meme piege deja documente et corrige sur les pages
       disciplines (snippets/discipline-faq-overrides.liquid). */
    if (window.matchMedia('(max-width: 991px)').matches) {
      if (icon.src.indexOf('icon-faq-minus') !== -1) {
        icon.src = icon.src.replace('icon-faq-minus', 'icon-faq-plus');
      }
      return;
    }
    /* Les deux assets existent ; on échange le nom de fichier dans l'URL, le
       paramètre ?v= restant est ignoré par le CDN (simple clé de cache). */
    icon.src = open
      ? icon.src.replace('icon-faq-plus', 'icon-faq-minus')
      : icon.src.replace('icon-faq-minus', 'icon-faq-plus');
  }

  function setState(item, open) {
    var answer = item.querySelector('.faq-answer');
    var row = item.querySelector('.faq-item-question-row');
    item.classList.toggle('is-open', open);
    if (answer) { if (open) { expand(answer); } else { collapse(answer); } }
    setIcon(item, open);
    if (row) row.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function openExclusive(item) {
    if (item.classList.contains('is-open')) {
      setState(item, false);
      return;
    }
    var list = item.closest('.faq-list') || document;
    list.querySelectorAll('.faq-item.is-open').forEach(function (other) {
      if (other !== item) setState(other, false);
    });
    setState(item, true);
  }

  function applyState() {
    document.querySelectorAll('.section-faq .faq-list .faq-item').forEach(function (item) {
      var answer = item.querySelector('.faq-answer');
      var row = item.querySelector('.faq-item-question-row');
      if (!answer || !row) return;
      answer.style.overflow = 'hidden';
      answer.style.transition = 'max-height .3s ease, opacity .3s ease';
      var open = item.classList.contains('is-open');
      if (open) { expand(answer); } else { collapse(answer); }
      setIcon(item, open);
      /* LOT D1 BIS (05/09) : role/tabindex retires, le bouton natif porte
         deja ces semantiques (cf. markup Liquid) -- seul aria-expanded
         reste pilote en JS puisqu'il change a chaque bascule. */
      row.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* LOT D1 BIS (05/09) : le clic délégué suffit désormais pour le clavier
     aussi -- un <button> natif déclenche lui-même un événement "click" sur
     Entrée/Espace (activation par défaut du navigateur), l'ancien handler
     "keydown" dédié (nécessaire du temps du <div role="button">) est retiré,
     il aurait risqué un double-toggle avec ce même listener. */
  document.addEventListener('click', function (e) {
    var item = e.target.closest('.section-faq .faq-list .faq-item');
    if (!item) return;
    if (e.target.closest('.faq-answer')) return;
    openExclusive(item);
  });

  /* Une réponse ouverte change de largeur au redimensionnement : on remet la
     hauteur à jour. */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll('.section-faq .faq-item.is-open .faq-answer').forEach(function (answer) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      });
    }, 150);
  });

  /* Le script de section est concaténé par Shopify dans un bundle commun :
     rien ne garantit qu'il s'exécute avant DOMContentLoaded. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyState);
  } else {
    applyState();
  }
  document.addEventListener('shopify:section:load', applyState);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Repli sans JS : jusqu'à 8 candidats sont rendus, seuls les 3 premiers
     sont visibles (les autres portent l'attribut `hidden`). Ici on tire 3
     slides au hasard parmi les 8 candidats à l'affichage : et on RETIRE du
     DOM (pas juste `hidden`) les 5 non retenus (PASSE UX/UI MOBILE 01/09,
     carrousel Splide) : nécessaire pour que Splide, monté juste après par
     initOne(), ne voie QUE les 3 slides réels, sinon les 5 slides masqués
     ([hidden], display:none) resteraient comptés par Splide (largeur 0 en
     mode autoWidth), faussant le nombre de points de pagination et la
     boucle. Idempotent sans flag dédié : un 2e passage (shopify:section:
     load) trouve déjà ≤3 candidats et sort immédiatement (garde ci-dessous),
     exactement comme avant ce correctif. */
  function shuffle(grid) {
    var slides = Array.prototype.slice.call(grid.querySelectorAll('[data-related-candidate]'));
    if (slides.length <= 3) return;
    for (var i = slides.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = slides[i];
      slides[i] = slides[j];
      slides[j] = tmp;
    }
    slides.forEach(function (slide, index) {
      if (index >= 3) {
        slide.remove();
      } else {
        slide.hidden = false;
      }
    });
  }

  /* Carrousel Splide (même lib/version/config que sections/home-seance.
     liquid, page-coaching-plus-combat.liquid et page-kids-teens-ados.
     liquid) monté UNIQUEMENT si la largeur est <=767px : au-dessus,
     `.related-grid` reste piloté par CSS pur (row desktop). Idempotent
     (dataset.odaSplideMounted). Appelé APRÈS shuffle() dans init() (même
     event, exécution synchrone) : le DOM est déjà réduit à 3 slides réels
     quand Splide compte ses slides au mount. */
  function initOne(root) {
    if (window.innerWidth > 767) return;
    var el = root.querySelector('.splide');
    if (!el || el.dataset.odaSplideMounted === '1') return;
    if (typeof Splide === 'undefined') return;
    var splideInstance = new Splide(el, {
      type: 'loop',
      autoWidth: true,
      height: 'auto',
      drag: 'free',
      snap: false,
      focus: 'start',
      arrows: false,
      pagination: true,
      waitForTransition: false,
      clones: 3
    });
    splideInstance.mount();
    el.dataset.odaSplideMounted = '1';
  }

  function init() {
    document.querySelectorAll('.section-boutique .cours-grid[data-related-random]').forEach(shuffle);
    document.querySelectorAll('.section-boutique .cours-track').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Filet de sécurité sur l'ordre d'exécution (même piège documenté dans
     home-seance.liquid) : le script de section peut s'exécuter avant le
     defer de splide.min.js posé plus haut : `load` arrive après tous les
     defer, initOne() est idempotent. */
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
/* Compteur anime des chiffres cles (retour Murat 06/09) : le nombre part de
   zero et monte jusqu a sa valeur quand la section entre dans l ecran, sur PC
   comme sur telephone. Une seule fois par chiffre. Respecte
   prefers-reduced-motion (aucune animation, valeur finale affichee). */
(function () {
  function initStatsCountUp() {
    var nums = document.querySelectorAll('.stats-number:not([data-oda-count])');
    if (!nums.length) return;
    if (!('IntersectionObserver' in window)
        || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        if (el.getAttribute('data-oda-count')) return;
        var raw = (el.textContent || '').trim();
        var m = raw.match(/^(\D*?)(\d+(?:[.,]\d+)?)(\D*)$/);
        if (!m) return;
        el.setAttribute('data-oda-count', '1');
        var prefix = m[1], suffix = m[3];
        var decimals = (m[2].split(/[.,]/)[1] || '').length;
        var target = parseFloat(m[2].replace(',', '.'));
        var start = null, duration = 1400;
        function frame(ts) {
          if (start === null) start = ts;
          var p = Math.min(1, (ts - start) / duration);
          var value = target * (1 - Math.pow(1 - p, 3));
          el.textContent = prefix + (decimals ? value.toFixed(decimals) : Math.round(value)) + suffix;
          if (p < 1) requestAnimationFrame(frame);
          else el.textContent = raw;
        }
        el.textContent = prefix + '0' + suffix;
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.35 });
    nums.forEach(function (n) { io.observe(n); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStatsCountUp);
  } else {
    initStatsCountUp();
  }
  document.addEventListener('shopify:section:load', initStatsCountUp);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tarifs-funnel"]) return;
  try {
    
(function () {
  'use strict';

  function fmtCHF(n) {
    var rounded = Math.round(n * 100) / 100;
    var hasDecimals = Math.round(rounded * 100) % 100 !== 0;
    var parts = hasDecimals ? rounded.toFixed(2).split('.') : [String(Math.round(rounded))];
    var grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f');
    return 'CHF\u00a0' + grouped + (hasDecimals ? '.' + parts[1] : '');
  }

  var EASE = 'var(--oda-ease)';
  var ANIM_MS = 320;
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var CHECK_SVG = '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true"><path d="M3 8.4l3.2 3.2L13 4.6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Fusion module : sélectionner Coaching+ Combat (1) ET Fighter Lab (2)
     fusionne automatiquement en Fighter Pro (3), et réciproquement.
     Réplique EXACTEMENT templates/page.tarifs.json (module-pro.settings.
     remplace = "coaching-combat, fighter-lab") ; indices fixes car ces 4
     modules sont des settings de section, pas des blocks éditables. */
  var MODULE_FUSION = { pair: [1, 2], into: 3 };

  /* ---------------------------------------------------------------------
     C. LES ÉTAPES DE LA BRANCHE, fonction PURE de l'état.
     Le récap ayant disparu (retour B), l'écran FINAL d'une branche est son
     dernier écran de choix : Rythme (adulte/abonnement), Discipline
     (enfant), Offre (adulte/séances).
     C'est aussi la source unique de la navigation : « précédent » =
     l'entrée d'indice i-1, une bulle validée = l'entrée d'indice < i. Plus
     de pile state.history, donc plus aucun moyen de la désynchroniser.
     --------------------------------------------------------------------- */
  function stepsFor(state) {
    if (state.role === 'enfant') {
      return [
        { id: 'role', key: 'profil' },
        { id: 'age', key: 'age' },
        { id: 'kid-discipline', key: 'discipline' }
      ];
    }
    if (state.role === 'adulte' && state.mode === 'pass') {
      return [
        { id: 'role', key: 'profil' },
        { id: 'adult-mode', key: 'formule' },
        { id: 'pass', key: 'pass' }
      ];
    }
    /* Retour F (07/09) : branche « Récupération & bilans », 4 bulles. */
    if (state.role === 'adulte' && state.mode === 'recup') {
      return [
        { id: 'role', key: 'profil' },
        { id: 'adult-mode', key: 'formule' },
        { id: 'recup-espace', key: 'espace' },
        { id: 'recup-offre', key: 'offre' }
      ];
    }
    var steps = [
      { id: 'role', key: 'profil' },
      { id: 'adult-mode', key: 'formule' },
      { id: 'univers', key: 'univers' }
    ];
    /* Combat+Prépa et Tout Odyssée sont des offres uniques : pas d'écran
       Discipline, donc pas de bulle Discipline (spec 02/09). */
    if (state.univers !== 'combat-prepa' && state.univers !== 'tout') {
      steps.push({ id: 'discipline', key: 'discipline' });
    }
    steps.push({ id: 'modules', key: 'modules' });
    steps.push({ id: 'frequence', key: 'frequence' });
    return steps;
  }

  function initFunnel(root) {
    if (root.__odaTarifsInit) return;
    root.__odaTarifsInit = true;

    var sectionId = root.getAttribute('data-section-id');
    var dataScript = document.getElementById('tarifs-funnel-offres-' + sectionId);
    var stringsScript = document.getElementById('tarifs-funnel-strings-' + sectionId);
    var allBlocks = [];
    var strings = {};
    try { allBlocks = dataScript ? JSON.parse(dataScript.textContent) : []; } catch (e) { allBlocks = []; }
    try { strings = stringsScript ? JSON.parse(stringsScript.textContent) : {}; } catch (e) { strings = {}; }
    var blocksByCle = {};
    allBlocks.forEach(function (b) { blocksByCle[b.cle] = b; });
    /* Libellé le plus long connu (42 offres) : gabarit « pire cas » pour la
       mesure de hauteur d'un bloc formule jamais encore hydraté. */
    var longestOfferLabel = allBlocks.reduce(function (acc, b) {
      return (b.label || '').length > acc.length ? b.label : acc;
    }, '');
    /* Même gabarit « pire cas » pour la description affichée dans le bloc
       formule de la branche Récupération (la seule qui l'affiche). */
    var longestRecupDesc = allBlocks.reduce(function (acc, b) {
      if (!b.espace || b.espace === 'na') return acc;
      return (b.description || '').length > acc.length ? b.description : acc;
    }, '');

    var screensWrap = root.querySelector('.tarifs-funnel-screens');
    var screens = [].slice.call(root.querySelectorAll('.tarifs-funnel-screen'));
    var backBtn = root.querySelector('[data-tarifs-back]');
    var stepperEl = root.querySelector('[data-tarifs-stepper]');
    var popup = root.closest('[data-booking-popup]');
    var card = root.closest('.booking-popup-card');
    var bodyEl = root.closest('.booking-popup-body');
    /* 56d : le scroll auto vers "Finalisez votre commande" ne doit jouer
       qu'UNE FOIS par passage sur l'écran widget (reset à chaque fermeture
       de la popup, cf. plus bas), pour ne jamais interrompre une saisie en
       cours si le widget se remet à jour ensuite (options cochées,
       validation de champ...). */
    var widgetScrollDone = false;
    var widgetScrollTimer = null;

    function freshState() {
      return {
        screen: 'role',
        role: null, age: null, kidDiscipline: null, mode: null,
        univers: null, etendue: null, discipline: null,
        modules: [], frequence: null, seanceCle: null,
        espace: null, recupCle: null, currentOffer: null
      };
    }
    var state = freshState();

    function screenEl(id) { return root.querySelector('.tarifs-funnel-screen[data-screen="' + id + '"]'); }
    function finalScreenId() { var s = stepsFor(state); return s[s.length - 1].id; }
    function stepIndexOf(id) {
      var s = stepsFor(state);
      for (var i = 0; i < s.length; i++) { if (s[i].id === id) return i; }
      return -1;
    }
    function setPriceSlot(el, prefix, amount, unit) {
      if (!el) return;
      el.innerHTML = '';
      if (!amount) return;
      if (prefix) {
        var p = document.createElement('span');
        p.className = 'config-option-price-prefix';
        p.textContent = prefix + ' ';
        el.appendChild(p);
      }
      var a = document.createElement('span');
      a.className = 'config-option-price-amount';
      a.textContent = amount;
      el.appendChild(a);
      if (unit) {
        var u = document.createElement('span');
        u.className = 'config-option-price-unit';
        u.textContent = unit;
        el.appendChild(u);
      }
    }

    /* --- Hydratation par écran (prix calculés depuis les blocks "offre") --- */
    function hydrateKidDiscipline() {
      var s = screenEl('kid-discipline');
      if (!s) return;
      var mmaJjb = s.querySelector('[data-value="mma-jjb"]');
      if (mmaJjb) mmaJjb.hidden = state.age !== '5-8';
      /* 08/09 (Yann) : Ados 14-18 ans = MMA ou Grappling (pas de JJB). La carte
         `jjb` change de libelle selon la tranche d'age, sa cle ne change pas. */
      var jjb = s.querySelector('[data-value="jjb"]');
      if (jjb) {
        var ados = state.age === '14-18';
        var lab = jjb.querySelector('[data-chip-label]');
        var sub = jjb.querySelector('.config-option-sub');
        var labTxt = jjb.getAttribute(ados ? 'data-label-ados' : 'data-label-default') || '';
        var subTxt = jjb.getAttribute(ados ? 'data-sub-ados' : 'data-sub-default') || '';
        if (lab) lab.textContent = labTxt;
        if (sub) { sub.textContent = subTxt; sub.hidden = !subTxt; }
      }
      /* Le choix « MMA + JJB » disparaît hors 5-8 ans : si c'était le choix
         courant, il n'est plus valide. */
      if (state.kidDiscipline === 'mma-jjb' && state.age !== '5-8') state.kidDiscipline = null;
      s.querySelectorAll('[data-choice]').forEach(function (c) {
        if (c.hidden) return;
        var b = blocksByCle['kid__' + state.age + '__' + c.getAttribute('data-value')];
        setPriceSlot(c.querySelector('[data-price-slot]'), '', b ? fmtCHF(b.prix) : '', b ? strings.unit_an : '');
      });
      renderFormule();
    }

    function hydrateUnivers() {
      var s = screenEl('univers');
      if (!s) return;
      var mins = {};
      allBlocks.forEach(function (b) {
        if (b.frequence !== 'engagement12') return;
        if (mins[b.univers] === undefined || b.prix < mins[b.univers]) mins[b.univers] = b.prix;
      });
      s.querySelectorAll('[data-choice]').forEach(function (c) {
        var u = c.getAttribute('data-value');
        if (mins[u] !== undefined) setPriceSlot(c.querySelector('[data-price-slot]'), strings.from_prefix, fmtCHF(mins[u]), strings.unit_mois);
      });
    }

    function hydrateDiscipline() {
      var s = screenEl('discipline');
      if (!s) return;
      var combatGroup = s.querySelector('[data-discipline-group="combat"]');
      var prepaGroup = s.querySelector('[data-discipline-group="prepa"]');
      if (combatGroup) combatGroup.hidden = state.univers !== 'combat';
      if (prepaGroup) prepaGroup.hidden = state.univers !== 'prepa';
      var group = state.univers === 'combat' ? combatGroup : (state.univers === 'prepa' ? prepaGroup : null);
      if (!group) return;
      group.querySelectorAll('[data-choice]').forEach(function (c) {
        var isAll = c.hasAttribute('data-all');
        var cle = isAll
          ? [state.univers, 'unlimited', 'na', 'engagement12'].join('__')
          : [state.univers, 'focus', c.getAttribute('data-value'), 'engagement12'].join('__');
        var b = blocksByCle[cle];
        if (b) setPriceSlot(c.querySelector('[data-price-slot]'), strings.from_prefix, fmtCHF(b.prix), strings.unit_mois);
      });
    }

    /* Modules choisis : somme de leurs prix mensuels (catalogue, comme
       l'option Sportigo : × 12 à l'annuel, sans remise) et contrainte
       « annuel uniquement » (décision Yann 26/08, identique page Tarifs). */
    function passBlock() {
      return blocksByCle[strings.pass_cle] || allBlocks.filter(function (o) { return /^seance__/.test(o.cle || ''); })[0] || null;
    }
    function modulesChoisis() {
      var out = [];
      root.querySelectorAll('[data-module-toggle]').forEach(function (c) {
        var idx = parseInt(c.getAttribute('data-module-index'), 10);
        if (state.modules.indexOf(idx) > -1) out.push(c);
      });
      return out;
    }
    /* 17/09 (Murat, confirme par les vocaux de Yann du 16/09) : Fitness Access
       est le SEUL module vendu sans engagement, a un prix propre
       (data-module-prix-se). Absent ou vide : meme prix qu'avec engagement. */
    function modulesMensuel(freq) {
      return modulesChoisis().reduce(function (t, c) {
        var se = c.getAttribute('data-module-prix-se');
        var p = (freq === 'sans-engagement' && se !== null && se !== '') ? parseFloat(se) : parseFloat(c.getAttribute('data-module-prix'));
        return t + (p || 0);
      }, 0);
    }
    /* Règle métier 02/09 : les modules de coaching exigent un ENGAGEMENT SUR
       L'ANNÉE, pas le paiement annuel. Le setting garde son id historique
       (module_N_annuel_seulement) pour ne perdre aucune valeur : il signifie
       désormais « bloque le sans engagement ». */
    function modulesExigentEngagement() {
      return modulesChoisis().some(function (c) { return c.getAttribute('data-module-annuel') === 'true'; });
    }
    function moduleLabels() {
      return modulesChoisis().map(function (c) { return c.getAttribute('data-module-label'); });
    }
    function prixAvecModules(b, freq) {
      return b ? b.prix + modulesMensuel(freq) * (freq === 'annuel' ? 12 : 1) : 0;
    }

    function moduleEligible(c) {
      var req = c.getAttribute('data-module-requiert') || 'none';
      /* 17/09 : en preparation physique, les modules combat ne sont proposes
         qu'avec les disciplines cochees dans les reglages, a l'image des
         options attachees aux formules dans Sportigo (Hybrid 360 : oui ;
         Calisthenics, HYROX, Toute la preparation : non). « all » = Toute la
         preparation. */
      if (req === 'combat') {
        if (state.univers !== 'prepa') return true;
        var cleDisc = state.etendue === 'unlimited' ? 'all' : (state.discipline || '');
        return (strings.modules_combat_prepa || []).indexOf(cleDisc) > -1;
      }
      return true;
    }
    function moduleInclus(c) {
      var lst = (c.getAttribute('data-module-inclus') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      return !!state.univers && lst.indexOf(state.univers) > -1;
    }
    function syncModuleCards() {
      root.querySelectorAll('[data-module-toggle]').forEach(function (c) {
        var idx = parseInt(c.getAttribute('data-module-index'), 10);
        var ok = moduleEligible(c), inc = moduleInclus(c);
        c.hidden = !ok;
        c.classList.toggle('is-included', ok && inc);
        c.setAttribute('aria-disabled', ok && inc ? 'true' : 'false');
        if ((!ok || inc) && state.modules.indexOf(idx) > -1) state.modules.splice(state.modules.indexOf(idx), 1);
        c.classList.toggle('is-active', state.modules.indexOf(idx) > -1);
        c.setAttribute('aria-pressed', state.modules.indexOf(idx) > -1 ? 'true' : 'false');
      });
    }
    function modulesInclusLabels() {
      var out = [];
      root.querySelectorAll('[data-module-toggle]').forEach(function (c) { if (moduleEligible(c) && moduleInclus(c)) out.push(c.getAttribute('data-module-label')); });
      return out;
    }
    function hydrateModules() {
      var s = screenEl('modules');
      if (!s) return;
      syncModuleCards();
      syncGridCols(s);
      var label = s.querySelector('[data-continue-label]');
      if (label) {
        label.textContent = state.modules.length
          ? (strings.modules_continue_label || 'Continuer')
          : (strings.modules_continue_empty_label || strings.modules_continue_label || 'Continuer');
      }
    }

    function hydrateFrequence() {
      var s = screenEl('frequence');
      if (!s) return;
      var exigeEngagement = modulesExigentEngagement();
      /* Le rythme est CONSERVÉ tant qu'il reste autorisé : seul « mensuel
         sans engagement » devient interdit quand un module de coaching est
         coché (règle 02/09) ; s'il était choisi, il est purgé. */
      if (exigeEngagement && state.frequence === 'sans-engagement') state.frequence = null;
      s.querySelectorAll('[data-choice]').forEach(function (c) {
        var freq = c.getAttribute('data-value');
        var cle = [state.univers, state.etendue, state.discipline || 'na', freq].join('__');
        var b = blocksByCle[cle];
        setPriceSlot(c.querySelector('[data-price-slot]'), '', b ? fmtCHF(prixAvecModules(b, freq)) : '', b ? (freq === 'annuel' ? strings.unit_an : strings.unit_mois) : '');
        /* 17/09 : un rythme sans offre (bloc masque ou fiche decochee) n'est
           plus propose : carte cachee, et purgee si elle etait choisie. */
        c.hidden = !b;
        if (!b && state.frequence === freq) state.frequence = null;
        var off = exigeEngagement && freq === 'sans-engagement';
        c.classList.toggle('is-disabled', off);
        c.setAttribute('aria-disabled', off ? 'true' : 'false');
      });
      syncGridCols(s);
      var note = s.querySelector('[data-frequence-note]');
      if (note) note.hidden = !exigeEngagement;
      renderFormule();
    }

    /* Écran Pass Découverte : nom + description longue lus sur le block
       désigné par le setting `pass_offer_cle` (aucune liste d'offres à la
       séance : Recovery et Regen sortent du parcours, règle 02/09). */
    function hydratePass() {
      var s = screenEl('pass');
      if (!s) return;
      var b = passBlock();
      state.seanceCle = b ? b.cle : null;
      var n = s.querySelector('[data-pass-name]');
      var d = s.querySelector('[data-pass-desc]');
      if (n) n.textContent = b ? b.label : '';
      if (d) { d.textContent = b ? (b.description || '') : ''; d.hidden = !(b && b.description); }
      renderFormule();
    }

    /* Offres de la branche Récupération : tous les blocks dont l'attribut
       `espace` est renseigné (recovery / regen / technogym). Source unique
       des cartes ET des prix « dès CHF … » des deux écrans amont. */
    function recupBlocks() {
      return allBlocks.filter(function (b) { return b.espace && b.espace !== 'na'; });
    }
    /* 08/09 (Murat) : un pack de N sessions vaut prix / N par session ; les
       « dès CHF … » de la branche partent de ce prix par session (150 / 10 =
       15), et le pack affiche badge + économie par rapport à la séance à
       l'unité du même espace (block sans nombre de sessions). */
    function prixSession(b) { return (b.sessions && b.sessions > 1) ? b.prix / b.sessions : b.prix; }
    function minPrix(list) {
      return list.reduce(function (m, b) { var p = prixSession(b); return (m === null || p < m) ? p : m; }, null);
    }
    function uniteDe(b) {
      return recupBlocks().filter(function (o) { return o.espace === b.espace && !(o.sessions > 1); })
        .sort(function (x, y) { return x.prix - y.prix; })[0] || null;
    }
    function economieDe(b) {
      if (!(b.sessions > 1)) return null;
      var u = uniteDe(b);
      if (!u) return null;
      var ref = u.prix * b.sessions, e = ref - b.prix;
      if (e <= 0) return null;
      return { economie: e, pct: Math.round(e / ref * 100), ref: ref, n: b.sessions };
    }
    function ligneEconomie(eco) {
      var t = strings.recup_saving_template || '';
      return t.replace('{economie}', fmtCHF(eco.economie)).replace('{pct}', String(eco.pct)).replace('{n}', String(eco.n));
    }

    /* Prix du Pass et prix plancher de la Récupération sur les cartes de
       l'étape 2. La carte Récupération disparaît si aucun block ne porte
       d'espace (porte qui ne mènerait nulle part). */
    function hydrateAdultMode() {
      var s = screenEl('adult-mode');
      if (!s) return;
      var b = passBlock();
      var c = s.querySelector('[data-choice][data-value="pass"]');
      if (c && b) setPriceSlot(c.querySelector('[data-price-slot]'), '', fmtCHF(b.prix), '');
      var r = s.querySelector('[data-choice][data-value="recup"]');
      if (r) {
        var liste = recupBlocks();
        var m = minPrix(liste);
        r.hidden = !liste.length;
        setPriceSlot(r.querySelector('[data-price-slot]'), strings.from_prefix, m === null ? '' : fmtCHF(m), '');
      }
    }

    /* Écran Espace : « dès CHF … » = minimum des blocks de chaque espace ;
       un espace sans block est masqué. */
    function hydrateRecupEspace() {
      var s = screenEl('recup-espace');
      if (!s) return;
      var mins = {};
      recupBlocks().forEach(function (b) {
        var p = prixSession(b);
        if (mins[b.espace] === undefined || p < mins[b.espace]) mins[b.espace] = p;
      });
      s.querySelectorAll('[data-choice]').forEach(function (c) {
        var k = c.getAttribute('data-value');
        c.hidden = mins[k] === undefined;
        setPriceSlot(c.querySelector('[data-price-slot]'), strings.from_prefix, mins[k] === undefined ? '' : fmtCHF(mins[k]), '');
      });
      if (state.espace && mins[state.espace] === undefined) { state.espace = null; state.recupCle = null; }
    }

    /* Écran FINAL de la branche : un seul groupe d'offres visible, celui de
       l'espace choisi. Prix lus sur les blocks, jamais écrits dans le JS. */
    function hydrateRecupOffre() {
      var s = screenEl('recup-offre');
      if (!s) return;
      s.querySelectorAll('[data-recup-group]').forEach(function (g) {
        g.hidden = g.getAttribute('data-recup-group') !== state.espace;
      });
      /* Un choix conservé qui n'appartient plus à l'espace courant n'est plus
         valide (même règle que « MMA + JJB » hors 5-8 ans). */
      if (state.recupCle) {
        var cur = blocksByCle[state.recupCle];
        if (!cur || cur.espace !== state.espace) state.recupCle = null;
      }
      s.querySelectorAll('[data-recup-group]:not([hidden]) [data-choice]').forEach(function (c) {
        var b = blocksByCle[c.getAttribute('data-value')];
        setPriceSlot(c.querySelector('[data-price-slot]'), '', b ? fmtCHF(b.prix) : '', '');
        var eco = b ? economieDe(b) : null;
        var badge = c.querySelector('[data-best-badge]');
        var per = c.querySelector('[data-persession-slot]');
        var sav = c.querySelector('[data-saving-slot]');
        if (badge) badge.hidden = !eco;
        if (per) {
          var pt = (b && b.sessions > 1) ? (strings.recup_per_session_template || '').replace('{prix}', fmtCHF(prixSession(b))) : '';
          per.textContent = pt; per.hidden = !pt;
        }
        if (sav) { var st = eco ? ligneEconomie(eco) : ''; sav.textContent = st; sav.hidden = !st; }
      });
      renderFormule();
    }

    function disciplinesLabel() {
      if (state.univers === 'combat-prepa') return strings.univers_combat_prepa_disciplines_label;
      if (state.univers === 'tout') return strings.univers_tout_disciplines_label;
      if (state.etendue === 'unlimited') {
        return state.univers === 'combat'
          ? [strings.label_mma, strings.label_strike, strings.label_grapple].join(' · ')
          : [strings.label_calisthenics, strings.label_hybride360].join(' · ');
      }
      var map = {
        mma: strings.label_mma, strike: strings.label_strike, grapple: strings.label_grapple,
        calisthenics: strings.label_calisthenics, 'hybride-360': strings.label_hybride360, hyrox: strings.label_hyrox
      };
      return map[state.discipline] || '';
    }

    /* Mise en avant HYROX (demande Yann 11/09) : remplit et affiche les deux
       emplacements (haut de l'écran Modules + bloc formule) uniquement quand
       la discipline choisie est HYROX ; sinon les masque. Aucune chaîne en
       dur : tout vient de strings.hyrox_note (réglage éditable de la
       section), donc rien à afficher si Yann le vide. */
    function updateHyroxNote() {
      var show = state.discipline === 'hyrox' && !!strings.hyrox_note;
      root.querySelectorAll('[data-hyrox-note]').forEach(function (n) {
        n.textContent = show ? strings.hyrox_note : '';
        n.hidden = !show;
      });
    }

    /* ---------------------------------------------------------------------
       B. BLOC FORMULE, rendu sous les cartes de l'écran final de la branche.
       Reprend À L'IDENTIQUE la logique de prix des anciens écrans récap :
       prix = offre Sportigo + modules au catalogue (× 12 à l'annuel) ;
         - annuel : barré = mensuel engagement × 12 (+ modules × 12),
           « vous économisez … sur l'année » ;
         - mensuel engagement : barré = mensuel sans engagement (+ modules),
           « vous économisez … par mois » ;
         - sans engagement : un seul prix, rien de barré.
       --------------------------------------------------------------------- */
    function fillFormule(box, data) {
      function el(sel) { return box.querySelector(sel); }
      function txt(sel, v) { var e = el(sel); if (e) e.textContent = v || ''; }
      function show(sel, on) { var e = el(sel); if (e) e.hidden = !on; }

      txt('[data-f-name]', data.name);
      show('[data-f-disciplines-row]', !!data.disciplines);
      txt('[data-f-disciplines]', data.disciplines);
      show('[data-f-modules-row]', !!data.modulesLine);
      txt('[data-f-modules]', data.modulesLine);
      show('[data-f-desc]', !!data.description);
      txt('[data-f-desc]', data.description);
      show('[data-f-note]', !!data.note);
      show('[data-f-price-old]', !!data.priceOld);
      txt('[data-f-price-old]', data.priceOld);
      txt('[data-f-price]', data.price);
      var priceEl = el('[data-f-price]');
      if (priceEl) priceEl.classList.toggle('is-discounted', !!data.priceOld);
      txt('[data-f-unit]', data.unit);
      show('[data-f-saving]', !!data.saving);
      txt('[data-f-saving]', data.saving);
      updateHyroxNote();
    }

    function renderFormule() {
      var sid = finalScreenId();
      var s = screenEl(sid);
      if (!s) return;
      var box = s.querySelector('[data-formule]');
      if (!box) return;

      var b = null;
      var data = { name: '', disciplines: '', modulesLine: '', description: '', note: false, priceOld: '', price: '', unit: '', saving: '' };

      if (sid === 'kid-discipline') {
        if (state.age && state.kidDiscipline) b = blocksByCle['kid__' + state.age + '__' + state.kidDiscipline];
        if (b) { data.name = b.label; data.price = fmtCHF(b.prix); data.unit = strings.unit_an; }
      } else if (sid === 'recup-offre') {
        if (state.recupCle) b = blocksByCle[state.recupCle];
        /* Paiement unique : pas d'unité ; barré + économie seulement pour un
           pack de N sessions comparé à la séance à l'unité (08/09). */
        if (b) {
          data.name = b.label; data.description = b.description || ''; data.price = fmtCHF(b.prix);
          var ecoR = economieDe(b);
          if (ecoR) { data.priceOld = fmtCHF(ecoR.ref); data.saving = ligneEconomie(ecoR); }
        }
      } else if (sid === 'pass') {
        b = passBlock();
        /* La description longue est déjà affichée au-dessus (écran Pass) :
           le bloc formule ne porte que le nom, le prix et le bouton. */
        if (b) { data.name = b.label; data.price = fmtCHF(b.prix); }
      } else {
        if (state.univers && state.etendue && state.frequence) {
          b = blocksByCle[[state.univers, state.etendue, state.discipline || 'na', state.frequence].join('__')];
        }
        if (b) {
          var labels = moduleLabels();
          var prix = prixAvecModules(b, state.frequence);
          var barre = 0, economie = 0, ligne = '';
          if (state.frequence === 'annuel') {
            var eB = blocksByCle[[state.univers, state.etendue, state.discipline || 'na', 'engagement12'].join('__')];
            if (eB) { barre = eB.prix * 12 + modulesMensuel() * 12; economie = barre - prix; ligne = strings.recap_economie_template || ''; }
          } else if (state.frequence === 'engagement12') {
            var seB = blocksByCle[[state.univers, state.etendue, state.discipline || 'na', 'sans-engagement'].join('__')];
            if (seB) { barre = seB.prix + modulesMensuel(); economie = barre - prix; ligne = strings.recap_economie_mensuelle_template || ''; }
          }
          data.name = b.label;
          data.disciplines = disciplinesLabel();
          var inclus = modulesInclusLabels().map(function (l) { return l + ' (' + (strings.recap_inclus_label || 'inclus') + ')'; });
          data.modulesLine = labels.concat(inclus).length ? labels.concat(inclus).join(', ') : (strings.recap_none_label || '');
          data.note = labels.length > 0;
          data.price = fmtCHF(prix);
          data.unit = state.frequence === 'annuel' ? strings.unit_an : strings.unit_mois;
          if (economie > 0) {
            data.priceOld = fmtCHF(barre);
            data.saving = ligne ? ligne.replace('{economie}', fmtCHF(economie)) : '';
          }
        }
      }

      state.currentOffer = b || null;
      box.hidden = !b;
      if (b) fillFormule(box, data);
    }

    /* LOT RESPONSIVE A (05/09, demande Murat points 56c/56d) : defilement
       manuel du SEUL conteneur reel (`bodyEl` = .booking-popup-body, deja
       capture plus haut ; jamais window/document, verrouilles pendant
       l'ouverture par html.booking-popup-open, cf. assets/oda-popups.js)
       plutot que scrollIntoView -- coherent avec le reste de ce fichier
       (mesures explicites via getBoundingClientRect, comme
       reserveBranchHeight/syncGridCols) et plus fiable sur Safari iOS pour
       un conteneur overflow imbrique dans une carte position:fixed.
       alignTop=false (56c, bloc formule) : ne revele que le BAS du
       rectangle (+ marge), defilement DOUX minimal -- le haut de l'ecran
       (titre, cartes) reste deja visible, rien a y faire remonter.
       alignTop=true (56d, ecran Sportigo) : amene le HAUT du rectangle
       pres du haut du cadre (+ marge), pour reveler aussi ce qui suit
       (boutons Connexion/Inscription, champs) -- le long texte d'offre
       au-dessus peut sortir du cadre, c'est le but. Ne scrolle JAMAIS vers
       le haut (delta negatif ignore) : uniquement un rattrapage vers le
       bas, jamais un mouvement surprise en sens inverse. */
    function scrollElementNear(rect, alignTop, margin) {
      if (!bodyEl || !rect) return;
      var bodyRect = bodyEl.getBoundingClientRect();
      var delta = alignTop
        ? (rect.top - bodyRect.top - margin)
        : (rect.bottom - bodyRect.bottom + margin);
      if (delta <= 0) return;
      var max = bodyEl.scrollHeight - bodyEl.clientHeight;
      var next = Math.min(bodyEl.scrollTop + delta, max);
      if (next <= bodyEl.scrollTop + .5) return;
      bodyEl.scrollTo({ top: next, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    /* 56c : dès qu'un rythme est choisi, le bloc formule (+ Souscrire)
       vient d'apparaître sous les 3 cartes -- défilement doux pour que son
       BAS (le bouton) soit visible, sans rien faire remonter (le titre/les
       cartes restent où l'utilisateur les regardait). No-op si tout tient
       déjà (cas fréquent desktop / grand viewport mobile). */
    function scrollFormuleIntoView() {
      var s = screenEl(finalScreenId());
      var box = s && s.querySelector('[data-formule]');
      if (!box || box.hidden) return;
      scrollElementNear(box.getBoundingClientRect(), false, 20);
    }

    var HYDRATORS = {
      'kid-discipline': hydrateKidDiscipline,
      'adult-mode': hydrateAdultMode,
      univers: hydrateUnivers,
      discipline: hydrateDiscipline,
      modules: hydrateModules,
      frequence: hydrateFrequence,
      pass: hydratePass,
      'recup-espace': hydrateRecupEspace,
      'recup-offre': hydrateRecupOffre
    };

    /* --- Grille : nombre de colonnes = options RÉELLEMENT visibles. --- */
    function syncGridCols(scopeEl) {
      if (!scopeEl) return;
      scopeEl.querySelectorAll('.tarifs-funnel-options').forEach(function (g) {
        if (g.hidden) return;
        var visible = [].slice.call(g.children).filter(function (it) { return !it.hidden; });
        if (!visible.length) return;
        g.style.setProperty('--n', visible.length);
        g.setAttribute('data-cols', String(visible.length));
      });
    }

    /* --- C. Stepper à bulles, les validées cliquables ---------------------- */
    var lastStepSig = null;
    function paintStepper(steps) {
      var beyond = state.screen === 'widget';
      var activeIdx = beyond ? steps.length : stepIndexOf(state.screen);
      stepperEl.innerHTML = '';
      steps.forEach(function (step, i) {
        var isDone = activeIdx > i;
        var isCurrent = i === activeIdx;
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'tarifs-stepper-item' + (isDone ? ' is-done is-clickable' : '') + (isCurrent ? ' is-current' : '');
        item.setAttribute('data-step-index', String(i));
        var name = strings['step_' + step.key] || '';
        if (isDone) {
          item.setAttribute('aria-label', (strings.step_back_aria || 'Revenir à l’étape {n}').replace('{n}', String(i + 1)).replace('{label}', name));
        } else {
          item.disabled = true;
          if (isCurrent) item.setAttribute('aria-current', 'step');
        }
        var bubble = document.createElement('span');
        bubble.className = 'tarifs-stepper-bubble';
        bubble.innerHTML = isDone ? CHECK_SVG : String(i + 1);
        var label = document.createElement('span');
        label.className = 'tarifs-stepper-label';
        label.textContent = name;
        item.appendChild(bubble);
        item.appendChild(label);
        stepperEl.appendChild(item);
        if (i < steps.length - 1) {
          var line = document.createElement('span');
          line.className = 'tarifs-stepper-line' + (activeIdx > i ? ' is-done' : '');
          stepperEl.appendChild(line);
        }
      });
    }

    var stepperTimer = null;
    function renderStepper() {
      if (!stepperEl) return;
      var steps = stepsFor(state);
      var sig = steps.map(function (s) { return s.id; }).join(',');
      /* Le fondu ne joue QUE quand la COMPOSITION des bulles change (profil
         enfant choisi, univers sans discipline…), jamais à chaque simple
         avancée d'étape : celle-ci se repeint directement. */
      if (lastStepSig === null || sig === lastStepSig || reduceMotion) {
        lastStepSig = sig;
        paintStepper(steps);
        stepperEl.style.opacity = '';
        return;
      }
      lastStepSig = sig;
      stepperEl.style.transition = 'opacity ' + ANIM_MS + 'ms ' + EASE;
      stepperEl.style.opacity = '0';
      window.clearTimeout(stepperTimer);
      stepperTimer = window.setTimeout(function () {
        paintStepper(steps);
        stepperEl.style.opacity = '1';
      }, ANIM_MS);
    }

    /* ---------------------------------------------------------------------
       E. HAUTEUR RÉSERVÉE ET PLAFONNÉE.
       La carte doit garder la même hauteur d'un écran à l'autre DANS une
       branche, mais ne jamais dépasser sa hauteur maximale : au-delà, c'est
       le corps qui défile, et surtout : AUCUNE barre de défilement tant que
       le contenu tient (le bug rapporté : 2 cartes et une scrollbar).
       On mesure hors-flux les écrans structurants de la branche (l'écran
       final, bloc formule compris, hydraté avec un contenu représentatif ,
       et l'écran Modules, les seuls susceptibles d'être les plus hauts),
       puis on plafonne à la place réellement disponible.
       Tant que le profil n'est pas choisi la branche est inconnue : on ne
       réserve rien (l'écran 1 garde sa hauteur naturelle, la transition CSS
       min-height fait le reste).
       --------------------------------------------------------------------- */
    function availableScreensHeight() {
      if (!card || !bodyEl) return 100000;
      var cardMax = parseFloat(getComputedStyle(card).maxHeight);
      if (!cardMax || isNaN(cardMax)) cardMax = window.innerHeight;
      cardMax = Math.min(cardMax, window.innerHeight);
      var bcs = getComputedStyle(bodyEl);
      var pad = (parseFloat(bcs.paddingTop) || 0) + (parseFloat(bcs.paddingBottom) || 0);
      var rcs = getComputedStyle(root);
      var gap = parseFloat(rcs.rowGap) || 0;
      var kids = [].slice.call(root.children);
      var other = 0;
      kids.forEach(function (ch) { if (ch !== screensWrap) other += ch.getBoundingClientRect().height; });
      return Math.max(160, cardMax - pad - other - gap * Math.max(0, kids.length - 1) - 2);
    }

    /* Mesure un écran hors-flux (même technique que .is-anim) sans toucher à
       l'écran réellement affiché. Pour l'écran final, le bloc formule est
       temporairement révélé et rempli d'un contenu « pire cas » : sans ça la
       mesure sous-évaluerait la hauteur (champs vides = 0px) et la carte
       grandirait au premier choix. Tout est restauré à l'identique. */
    function measureScreen(el, asFinal) {
      var wasActive = el.classList.contains('is-active');
      var prevCss = el.style.cssText;
      if (!wasActive) el.style.cssText = 'display:block;visibility:hidden;position:absolute;top:0;left:0;width:100%;';
      syncGridCols(el);

      var box = asFinal ? el.querySelector('[data-formule]') : null;
      var restore = [];

      /* Emplacements de prix encore vides (ecran pas encore hydrate) : une
         ligne de prix represente ~1 ligne de plus par carte. Sans ce
         remplissage la hauteur reservee etait trop courte et la carte
         grandissait au premier choix. */
      el.querySelectorAll('[data-price-slot]').forEach(function (sl) {
        if (sl.innerHTML) return;
        restore.push({ el: sl, prop: 'html', val: sl.innerHTML });
        sl.innerHTML = '<span class="config-option-price-amount">CHF 1 599</span><span class="config-option-price-unit">/an</span>';
      });
      /* Note « modules de coaching » : masquee tant qu'aucun module n'est
         coche, mais elle occupe de la place des qu'il y en a un. */
      var fnote = el.querySelector('[data-frequence-note]');
      if (fnote && fnote.hidden) { restore.push({ el: fnote, prop: 'hidden', val: true }); fnote.hidden = false; }
      if (box) {
        /* Contenu « pire cas » PROPRE À LA BRANCHE : réserver la place des
           lignes disciplines/modules/économie sur la branche enfant ou
           Pass (qui ne les affichent jamais) laisserait un vide sous les
           cartes. On ne révèle donc que ce que cette branche affichera. */
        var sid = el.getAttribute('data-screen');
        var lignes = sid === 'frequence'
          ? ['[data-f-disciplines-row]', '[data-f-modules-row]', '[data-f-note]', '[data-f-price-old]', '[data-f-saving]']
          : (sid === 'recup-offre' ? ['[data-f-desc]', '[data-f-price-old]', '[data-f-saving]'] : []);
        restore.push({ el: box, prop: 'hidden', val: box.hidden });
        box.hidden = false;
        [['[data-f-name]', longestOfferLabel || 'Formule Odyssée Academy'],
         ['[data-f-disciplines]', 'MMA · Strike · Grappling'],
         ['[data-f-modules]', 'Coaching+ Combat, Fighter Lab'],
         ['[data-f-price-old]', 'CHF 2 136'],
         ['[data-f-price]', 'CHF 1 993'],
         ['[data-f-unit]', strings.unit_an || '/an'],
         ['[data-f-saving]', (strings.recap_economie_template || '').replace('{economie}', 'CHF 143')],
         ['[data-f-desc]', longestRecupDesc || '']
        ].forEach(function (pair) {
          var t = box.querySelector(pair[0]);
          if (!t) return;
          restore.push({ el: t, prop: 'text', val: t.textContent });
          t.textContent = pair[1];
        });
        lignes.forEach(function (sel) {
          var t = box.querySelector(sel);
          if (!t) return;
          restore.push({ el: t, prop: 'hidden', val: t.hidden });
          t.hidden = false;
        });
      }

      /* Écran à groupes (recup-offre) : la hauteur retenue est celle du
         groupe le PLUS HAUT, sinon la carte grandirait en arrivant sur un
         espace plus bavard que celui mesuré (la signature de
         reserveBranchHeight ne change pas entre les écrans d'une branche,
         donc la mesure n'est faite qu'une fois). */
      var h = 0;
      var groupes = [].slice.call(el.querySelectorAll('[data-recup-group]'));
      if (groupes.length) {
        var etatGroupes = groupes.map(function (g) { return g.hidden; });
        groupes.forEach(function (g, gi) {
          groupes.forEach(function (o, oi) { o.hidden = oi !== gi; });
          syncGridCols(el);
          var gh = el.getBoundingClientRect().height;
          if (gh > h) h = gh;
        });
        groupes.forEach(function (g, gi) { g.hidden = etatGroupes[gi]; });
        syncGridCols(el);
      } else {
        h = el.getBoundingClientRect().height;
      }

      restore.forEach(function (r) {
        if (r.prop === 'hidden') r.el.hidden = r.val;
        else if (r.prop === 'html') r.el.innerHTML = r.val;
        else r.el.textContent = r.val;
      });
      if (!wasActive) el.style.cssText = prevCss;
      return h;
    }

    var lastHeightSig = null;
    function reserveBranchHeight(force) {
      if (!screensWrap) return;
      /* LOT RESPONSIVE A BIS (05/09, retour contrôle point 1) : ce mécanisme
         mesure l'écran le plus haut de la branche (final/modules) et réserve
         cette hauteur sur TOUS les écrans de la branche -- pensé pour le
         DESKTOP (carte stable dans une branche, cf. retour E en tête de
         fichier). Sous 767px la carte est en `height:auto` (56a, plus haut) :
         réserver la hauteur de l'écran le plus haut faisait grandir la carte
         dès l'écran 1 choisi (adult-mode, univers, discipline...), bien plus
         courts, avec un VIDE NOIR sous leur contenu réel. Sous ce seuil,
         chaque écran garde sa hauteur naturelle (aucune réservation) ; si un
         écran déborde malgré tout du viewport, `max-height` + le défilement
         interne de `.booking-popup-body` (56a, inchangés) prennent le relais.
         Desktop (>767px) : branche ci-dessous strictement inchangée. */
      if (!state.role || window.innerWidth <= 767) {
        /* Branche inconnue OU mobile : hauteur naturelle (pas de zone
           réservée démesurée sous deux cartes, donc pas de scrollbar/vide). */
        screensWrap.style.minHeight = '';
        lastHeightSig = null;
        return;
      }
      var steps = stepsFor(state);
      var sig = steps.map(function (s) { return s.id; }).join(',') + '|' + window.innerWidth + 'x' + window.innerHeight;
      if (!force && sig === lastHeightSig) return;
      var finalId = steps[steps.length - 1].id;
      var ids = [finalId];
      if (steps.some(function (s) { return s.id === 'modules'; })) ids.push('modules');
      var maxH = 0;
      ids.forEach(function (id) {
        var el = screenEl(id);
        if (!el) return;
        var h = measureScreen(el, id === finalId);
        if (h > maxH) maxH = h;
      });
      if (maxH <= 0) return;
      screensWrap.style.minHeight = Math.min(maxH, availableScreensHeight()) + 'px';
      lastHeightSig = sig;
    }

    /* --- Navigation -------------------------------------------------------- */
    function markActive(screenId) {
      var s = screenEl(screenId);
      if (!s) return;
      var ACTIVE_STATE_KEY = {
        role: 'role', age: 'age', 'kid-discipline': 'kidDiscipline',
        'adult-mode': 'mode', univers: 'univers', frequence: 'frequence',
        'recup-espace': 'espace', 'recup-offre': 'recupCle'
      };
      var key = ACTIVE_STATE_KEY[screenId];
      if (key) {
        s.querySelectorAll('[data-choice]').forEach(function (c) {
          c.classList.toggle('is-active', state[key] != null && c.getAttribute('data-value') === state[key]);
        });
      }
      if (screenId === 'discipline') {
        s.querySelectorAll('[data-choice]').forEach(function (c) {
          var isAll = c.hasAttribute('data-all');
          var active = isAll ? state.etendue === 'unlimited' : (state.etendue === 'focus' && c.getAttribute('data-value') === state.discipline);
          c.classList.toggle('is-active', active);
        });
      }
      if (screenId === 'modules') {
        s.querySelectorAll('[data-module-toggle]').forEach(function (c) {
          var idx = parseInt(c.getAttribute('data-module-index'), 10);
          c.classList.toggle('is-active', state.modules.indexOf(idx) > -1);
        });
      }
    }

    function markAllActive() {
      screens.forEach(function (sc) { markActive(sc.getAttribute('data-screen')); });
      root.querySelectorAll('[data-choice], [data-module-toggle]').forEach(function (c) { c.setAttribute('aria-pressed', c.classList.contains('is-active') ? 'true' : 'false'); });
    }

    /* dirSign : 1 = avant (entre depuis la droite), -1 = arrière (entre
       depuis la gauche) ; 0/absent = instantané (premier affichage, reset à
       la fermeture, jamais d'animation à vide).

       animGen (jeton de génération) : si la popup est réinitialisée pendant
       qu'une transition est en vol, le setTimeout programmé plus tôt
       retirerait "is-active" du MAUVAIS écran. Chaque animation capture le
       jeton courant ; le nettoyage différé ne s'applique que s'il est
       toujours le plus récent. */
    var animGen = 0;
    /* Verrou de navigation : pendant une transition (ANIM_MS), les clics sur
       les cartes / Continuer / Retour / bulles sont ignorés. Sans lui, un
       double-clic atterrit sur la carte de l'écran suivant (déjà affiché en
       fondu) et deux transitions en vol laissent des écrans superposés. */
    var animLock = 0;
    function animateScreens(fromEl, toEl, dirSign) {
      animGen++;
      var myGen = animGen;
      animLock = Date.now() + ANIM_MS + 40;
      /* Tout écran qui ne participe pas à cette transition est nettoyé :
         aucun résidu d'une transition interrompue ne peut rester affiché. */
      screens.forEach(function (sc) {
        if (sc !== fromEl && sc !== toEl) { sc.classList.remove('is-active', 'is-anim'); sc.style.cssText = ''; }
      });
      if (!fromEl || !toEl || fromEl === toEl || !dirSign || reduceMotion) {
        screens.forEach(function (s) { s.classList.toggle('is-active', s === toEl); s.style.cssText = ''; });
        screensWrap.style.height = '';
        screensWrap.style.transition = '';
        screensWrap.style.overflow = '';
        return;
      }
      var startH = screensWrap.getBoundingClientRect().height;

      toEl.classList.add('is-active', 'is-anim');
      toEl.style.transition = 'none';
      toEl.style.transform = 'translateX(' + (dirSign * 28) + 'px)';
      toEl.style.opacity = '0';

      var endH = toEl.getBoundingClientRect().height;

      screensWrap.style.overflow = 'hidden';
      screensWrap.style.height = startH + 'px';

      fromEl.classList.add('is-anim');
      fromEl.style.transition = 'none';
      fromEl.style.transform = 'translateX(0)';
      fromEl.style.opacity = '1';

      // Force reflow : les valeurs de départ doivent être commises avant de
      // programmer la transition, sinon le navigateur les fusionne.
      void screensWrap.offsetHeight;

      requestAnimationFrame(function () {
        if (myGen !== animGen) return;
        screensWrap.style.transition = 'height ' + ANIM_MS + 'ms ' + EASE;
        screensWrap.style.height = endH + 'px';

        toEl.style.transition = 'transform ' + ANIM_MS + 'ms ' + EASE + ', opacity ' + ANIM_MS + 'ms ' + EASE;
        toEl.style.transform = 'translateX(0)';
        toEl.style.opacity = '1';

        fromEl.style.transition = 'transform ' + ANIM_MS + 'ms ' + EASE + ', opacity ' + ANIM_MS + 'ms ' + EASE;
        fromEl.style.transform = 'translateX(' + (-dirSign * 28) + 'px)';
        fromEl.style.opacity = '0';
      });

      window.setTimeout(function () {
        if (myGen !== animGen) return;
        fromEl.classList.remove('is-active', 'is-anim');
        fromEl.style.cssText = '';
        toEl.classList.remove('is-anim');
        toEl.style.cssText = '';
        screensWrap.style.height = '';
        screensWrap.style.transition = '';
        screensWrap.style.overflow = '';
      }, ANIM_MS + 20);
    }

    function showScreen(id, dirSign) {
      var prevEl = screenEl(state.screen);
      state.screen = id;
      var nextEl = screenEl(id);
      var h = HYDRATORS[id];
      if (h) h();
      updateHyroxNote();
      /* On remarque TOUS les écrans, pas seulement l'entrant : l'écran qu'on
         quitte reste visible ~320ms (fondu sortant) et un écran purgé mais
         non visité garderait sinon une carte rouge périmée. markActive est
         une pure lecture de state, la répéter sur 12 écrans ne coûte rien. */
      markAllActive();
      syncGridCols(nextEl);
      if (backBtn) backBtn.hidden = (id === 'role');
      renderStepper();
      reserveBranchHeight();
      animateScreens(prevEl, nextEl, dirSign || 0);
      if (dirSign && nextEl) {
        var t = nextEl.querySelector('.tarifs-funnel-title');
        if (t) { t.setAttribute('tabindex', '-1'); try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
      }
    }

    function goto(id) { showScreen(id, 1); }

    /* RETOUR = TOUJOURS l'étape précédente réelle de la branche en cours. */
    function back() {
      if (state.screen === 'widget') { showScreen(finalScreenId(), -1); return; }
      var steps = stepsFor(state);
      var i = stepIndexOf(state.screen);
      if (i > 0) showScreen(steps[i - 1].id, -1);
    }

    /* Clic sur une bulle VALIDÉE : retour à cette étape. Les bulles futures
       sont désactivées (disabled), donc inaccessibles. */
    function goStep(i) {
      var steps = stepsFor(state);
      var cur = state.screen === 'widget' ? steps.length : stepIndexOf(state.screen);
      if (i < 0 || i >= steps.length || i >= cur) return;
      showScreen(steps[i].id, -1);
    }

    function resetModulesChips() {
      state.modules = [];
      root.querySelectorAll('[data-module-toggle]').forEach(function (c) { c.classList.remove('is-active'); });
    }

    /* Purges : uniquement quand le choix CHANGE (revenir en arrière puis
       reconfirmer le même choix ne perd rien). */
    var SCREEN_HANDLERS = {
      role: function (value) {
        if (state.role !== value) {
          state.age = null; state.kidDiscipline = null; state.mode = null;
          state.univers = null; state.etendue = null; state.discipline = null;
          state.frequence = null; state.seanceCle = null;
          resetModulesChips();
        }
        state.role = value;
        goto(value === 'adulte' ? 'adult-mode' : 'age');
      },
      age: function (value) {
        if (state.age !== value) state.kidDiscipline = null;
        state.age = value;
        goto('kid-discipline');
      },
      /* Écran FINAL de la branche enfant : pas de navigation, on remplit le
         bloc formule sous les cartes. */
      'kid-discipline': function (value) {
        state.kidDiscipline = value;
        markAllActive();
        renderFormule();
      },
      'adult-mode': function (value) {
        if (state.mode !== value) {
          state.univers = null; state.etendue = null; state.discipline = null;
          state.frequence = null; state.seanceCle = null;
          state.espace = null; state.recupCle = null;
          resetModulesChips();
        }
        state.mode = value;
        if (value === 'abonnement') goto('univers');
        else if (value === 'recup') goto('recup-espace');
        else goto('pass');
      },
      /* Changer d'espace invalide l'offre choisie (elle appartenait à
         l'autre espace). */
      'recup-espace': function (value) {
        if (state.espace !== value) state.recupCle = null;
        state.espace = value;
        goto('recup-offre');
      },
      /* Écran FINAL de la branche Récupération : pas de navigation, on
         remplit le bloc formule sous les cartes. */
      'recup-offre': function (value) {
        state.recupCle = value;
        markAllActive();
        renderFormule();
        scrollFormuleIntoView();
      },
      univers: function (value) {
        /* Changer d'univers invalide la discipline ET les modules (spec). */
        if (state.univers !== value) {
          state.etendue = null; state.discipline = null;
          resetModulesChips();
        }
        state.univers = value;
        if (value === 'combat' || value === 'prepa') { goto('discipline'); }
        else { state.etendue = 'unique'; goto('modules'); }
      },
      /* Changer de discipline GARDE les modules (même univers, spec). */
      discipline: function (value, el) {
        if (el.hasAttribute('data-all')) { state.etendue = 'unlimited'; state.discipline = null; }
        else { state.etendue = 'focus'; state.discipline = value; }
        goto('modules');
      },
      /* Écran FINAL de la branche adulte/abonnement. */
      frequence: function (value) {
        state.frequence = value;
        markAllActive();
        renderFormule();
        scrollFormuleIntoView();
      }
    };

    /* Fusion symétrique Coaching+Combat/Fighter Lab <-> Fighter Pro, répliquée
       de templates/page.tarifs.json. Toggle OFF = simple désélection ; seul le
       toggle ON déclenche la cascade. */
    function toggleModuleIdx(idx) {
      var pos = state.modules.indexOf(idx);
      if (pos > -1) {
        state.modules.splice(pos, 1);
      } else {
        if (MODULE_FUSION.pair.indexOf(idx) > -1) {
          state.modules = state.modules.filter(function (k) { return k !== MODULE_FUSION.into; });
        } else if (idx === MODULE_FUSION.into) {
          state.modules = state.modules.filter(function (k) { return MODULE_FUSION.pair.indexOf(k) === -1; });
        }
        state.modules.push(idx);
        if (MODULE_FUSION.pair.every(function (k) { return state.modules.indexOf(k) > -1; })) {
          state.modules = state.modules.filter(function (k) { return MODULE_FUSION.pair.indexOf(k) === -1; });
          if (state.modules.indexOf(MODULE_FUSION.into) === -1) state.modules.push(MODULE_FUSION.into);
        }
      }
      hydrateModules();
    }

    /* Libellés des modules choisis, séparés par "|", pour data-options
       (précochage des options du widget Sportigo par
       assets/sportigo-planning.js). state.modules reflète déjà la fusion. */
    function moduleOptionsString() { return moduleLabels().join('|'); }

    /* 56d : dès que le widget Sportigo (monté dans #tarifs-funnel-sportigo,
       shadow DOM) a rendu son écran "Finalisez votre commande", défilement
       automatique vers CE bloc (le texte d'offre Sportigo qui précède --
       description, "cours inclus", "pour qui ?"... -- reste au-dessus,
       hors du cadre, exactement le "on tombe d'abord sur le texte de
       Sportigo" signalé). Repère le libellé EXACT confirmé au clic réel
       (CDP, 05/09, offre Combat Focus MMA annuel : le widget affiche
       "Finalisez votre commande" -- impératif -- immédiatement, PAS
       seulement après connexion contrairement au commentaire d'origine de
       assets/sportigo-planning.js sur les OPTIONS de modules ; formulation
       de Murat "Finaliser votre commande" tentée en second essai, au cas
       où une offre différente varierait). Repli sur le premier bouton ou
       champ de formulaire du widget (utilitaires exposés par LE PATCH
       MINIMAL de assets/sportigo-planning.js, window.OdaSportigoPlanning.
       findText/firstField) si le libellé n'est jamais trouvé. Une seule
       fois par passage (widgetScrollDone), pour ne jamais gêner une
       saisie déjà commencée ; le pré-cochage des modules (assets/
       sportigo-planning.js, précocherOptions, 0 ligne touchée) continue
       d'opérer en parallèle, totalement indépendant de cet observateur en
       LECTURE SEULE.

       LOT RESPONSIVE A BIS (05/09, retour contrôle point 3) : deux
       correctifs, mêmes garde-fous (LECTURE SEULE, aucune ligne de
       précocherOptions touchée).
       1) Marge ciblée AGRANDIE sous 767px (24 -> ~62px) : la croix de
          fermeture de la popup (`.booking-popup-close`, position absolue
          coin haut-droit) mesure jusqu'à 53-54px de haut à ces largeurs
          (cf. sections/global-popups.liquid) ; une cible calée à 24px du
          haut du cadre passait donc SOUS elle. Desktop (24px) inchangé, la
          croix y est plus petite et le corps de la carte bien plus haut.
       2) RECALAGE CONTINU une fois la cible trouvée : le widget peut
          encore insérer du contenu (résumé de commande) juste au-dessus
          d'elle après ce premier calage, ce qui laissait parfois un
          reliquat de texte remonter sous la croix. On continue de recaler
          sur la MÊME cible quelques itérations de plus (mêmes 200ms,
          `scrollElementNear` n'ignore que les deltas négatifs -- jamais de
          saut en arrière) avant d'arrêter définitivement l'observateur. */
    function watchWidgetFinalisation() {
      window.clearInterval(widgetScrollTimer);
      if (widgetScrollDone) return;
      var mount = document.getElementById('tarifs-funnel-sportigo');
      if (!mount || !window.OdaSportigoPlanning) return;
      var tries = 0;
      var margeVisee = window.innerWidth <= 767 ? 62 : 24;
      var arretTries = null; // posé au 1er calage réussi, quelques recalages de plus avant d'arrêter
      widgetScrollTimer = window.setInterval(function () {
        tries++;
        if (widgetScrollDone || state.screen !== 'widget') { window.clearInterval(widgetScrollTimer); return; }
        var cible = null;
        if (window.OdaSportigoPlanning.findText) {
          cible = window.OdaSportigoPlanning.findText(mount, 'Finalisez votre commande')
            || window.OdaSportigoPlanning.findText(mount, 'Finaliser votre commande');
        }
        if (!cible && tries > 45 && window.OdaSportigoPlanning.firstField) {
          cible = window.OdaSportigoPlanning.firstField(mount);
        }
        if (cible) {
          scrollElementNear(cible.getBoundingClientRect(), true, margeVisee);
          if (arretTries === null) arretTries = tries + 10; // ~2s de recalage supplémentaire
          if (tries >= arretTries) {
            widgetScrollDone = true;
            window.clearInterval(widgetScrollTimer);
          }
          return;
        }
        if (tries > 150) window.clearInterval(widgetScrollTimer); // ~30s, abandon silencieux
      }, 200);
    }

    /* CONTRAT SOUSCRIRE, inchangé par la refonte. */
    function onSouscrire() {
      var b = state.currentOffer;
      if (!b) return;
      var mount = document.getElementById('tarifs-funnel-sportigo');
      var offerId = String(b.sportigoId || '');
      var onlyOfferId = String(b.sportigoOfferId || '');
      var optionsStr = state.role === 'adulte' && state.mode === 'abonnement' ? moduleOptionsString() : '';
      /* 16/09 (Yann) : Sportigo propose chaque module en deux options
         distinctes, « ... ANNUEL » et « ... MENSUEL ». Le rythme choisi part
         avec le widget : assets/sportigo-planning.js masque les options de
         l'autre rythme et pre-coche la bonne variante. Vide hors abonnement
         adulte (kids, pass, recuperation : aucune option). */
      var rythme = state.role === 'adulte' && state.mode === 'abonnement' && state.frequence
        ? (state.frequence === 'annuel' ? 'annuel' : 'mensuel') : '';
      if (mount) {
        var changed = mount.getAttribute('data-offer-id') !== offerId || mount.getAttribute('data-only-offer-id') !== onlyOfferId || mount.getAttribute('data-options') !== optionsStr || (mount.getAttribute('data-rythme') || '') !== rythme;
        mount.setAttribute('data-offer-id', offerId);
        mount.setAttribute('data-only-offer-id', onlyOfferId);
        mount.setAttribute('data-options', optionsStr);
        if (rythme) { mount.setAttribute('data-rythme', rythme); } else { mount.removeAttribute('data-rythme'); }
        /* 16/09 : donnees du recapitulatif « avec vos options » affiche dans le
           widget Sportigo, calculees comme le bloc formule de l'etape
           precedente mais SANS les modules : le script ajoute les options
           reellement cochees dans Sportigo (prix barre, total, economie). */
        var refB = null, ecoTpl = '';
        if (rythme && state.frequence === 'annuel') {
          var eRef = blocksByCle[[state.univers, state.etendue, state.discipline || 'na', 'engagement12'].join('__')];
          if (eRef) { refB = eRef.prix * 12; ecoTpl = strings.recap_economie_template || ''; }
        } else if (rythme && state.frequence === 'engagement12') {
          var sRef = blocksByCle[[state.univers, state.etendue, state.discipline || 'na', 'sans-engagement'].join('__')];
          if (sRef) { refB = sRef.prix; ecoTpl = strings.recap_economie_mensuelle_template || ''; }
        }
        mount.setAttribute('data-prix-base', rythme && b.prix != null ? String(b.prix) : '');
        mount.setAttribute('data-ref-base', refB !== null ? String(refB) : '');
        mount.setAttribute('data-eco-template', ecoTpl);
        mount.setAttribute('data-unite', rythme ? (state.frequence === 'annuel' ? (strings.unit_an || '') : (strings.unit_mois || '')) : '');
        if (changed) {
          mount.removeAttribute('data-mounted');
          mount.innerHTML = '';
        }
      }
      goto('widget');
      widgetScrollDone = false;
      watchWidgetFinalisation();
    }

    root.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-tarifs-back], [data-module-toggle], [data-tarifs-continue], [data-choice], [data-step-index], [data-tarifs-souscrire]');
      if (nav && Date.now() < animLock) { e.preventDefault(); return; }
      if (nav && (nav.classList.contains('is-disabled') || nav.getAttribute('aria-disabled') === 'true')) { e.preventDefault(); return; }
      if (e.target.closest('[data-tarifs-back]')) { back(); return; }

      var bubble = e.target.closest('[data-step-index]');
      if (bubble) { goStep(parseInt(bubble.getAttribute('data-step-index'), 10)); return; }

      var moduleChip = e.target.closest('[data-module-toggle]');
      if (moduleChip) { toggleModuleIdx(parseInt(moduleChip.getAttribute('data-module-index'), 10)); return; }

      if (e.target.closest('[data-tarifs-continue]')) { goto('frequence'); return; }
      if (e.target.closest('[data-tarifs-souscrire]')) { onSouscrire(); return; }

      var chip = e.target.closest('[data-choice]');
      if (chip) {
        var screenNode = chip.closest('[data-screen]');
        var screenId = screenNode ? screenNode.getAttribute('data-screen') : null;
        var handler = screenId && SCREEN_HANDLERS[screenId];
        if (handler) handler(chip.getAttribute('data-value'), chip);
      }
    });

    /* Réinitialise le parcours à la fermeture : chaque ouverture repart de
       l'écran 1. Reset toujours instantané (pas de dirSign) : la popup est
       masquée, une animation n'y serait ni vue ni utile. À l'ouverture, on
       (re)mesure la hauteur disponible, qui dépend du viewport. */
    if (popup) {
      var wasOpen = popup.classList.contains('is-open');
      new MutationObserver(function () {
        var isOpen = popup.classList.contains('is-open');
        if (isOpen === wasOpen) return;
        wasOpen = isOpen;
        if (!isOpen) {
          state = freshState();
          window.clearTimeout(stepperTimer);
          if (stepperEl) stepperEl.style.opacity = '';
          lastStepSig = null;
          lastHeightSig = null;
          screensWrap.style.minHeight = '';
          resetModulesChips();
          root.querySelectorAll('[data-formule]').forEach(function (b) { b.hidden = true; });
          window.clearInterval(widgetScrollTimer);
          widgetScrollDone = false;
          showScreen('role');
        } else {
          window.setTimeout(function () { reserveBranchHeight(true); }, 60);
        }
      }).observe(popup, { attributes: true, attributeFilter: ['class'] });
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { reserveBranchHeight(true); }, 160);
    });

    showScreen('role');
  }

  function boot() {
    var root = document.getElementById('tarifs-funnel-root');
    if (root) initFunnel(root);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();

  } catch(e) { console.error(e); }
})();
})();
